import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import Switch from "@mui/material/Switch";
import config from '../../envconfig';
import React, { useContext, useEffect, useState, useRef } from "react";
import axios from "axios";
// import { Tree } from "primereact/tree";
import Tree from 'rc-tree';
import 'rc-tree/assets/index.css';
import { Link } from 'react-router-dom';

import { UserContext } from "../common/UserContext";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { IoCalendarOutline } from 'react-icons/io5';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import Select from 'react-select';
import { IoCaretUpOutline, IoCaretDownOutline } from 'react-icons/io5';
import { set } from "date-fns";
import CustomSingleValue from '../common/CustomSingleValue';

const CCHome = () => {
  const [companyOptions, setCompanyOptions] = useState([]);
  const [comtype, setComType] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState(null);
  const [nodes, setNodes] = useState([]);
  const [rightVal, setRightVal] = useState([]);
  const [userLimitOption, setUserLimitOption] = useState([]);
  const [rsnLimitOption, setRsnLimitOption] = useState([]);
  const [selectedType, setSelectedType] = useState(null);
  const [isMaxUser, setIsMaxUser] = useState(true);
  const [isMaxRSN, setIsMaxRSN] = useState(true);
  const [tandtoption, setTndTOption] = useState([]);
  const [fieldOption, setFieldOption] = useState([]);
  const [disabledKeys, setDisabledKeys] = useState(new Set());
  const [packingOption, setPackingOption] = useState([]);
  const [isSelectOpen, setIsSelectOpen] = useState(null);

  // New state variables for additional fields
  const [dateFormatOptions, setDateFormatOptions] = useState([]);
  const [selectedDateFormat, setSelectedDateFormat] = useState(null);
  const [companyChannelOptions, setCompanyChannelOptions] = useState([]);
  const [selectedCompanyChannels, setSelectedCompanyChannels] = useState([]);
  const [companyEventTypeOptions, setCompanyEventTypeOptions] = useState([]);
  const [selectedCompanyEventTypes, setSelectedCompanyEventTypes] = useState([]);

  const [configuredCompanyIds, setConfiguredCompanyIds] = useState([]);
  const { UM_UserId } = useContext(UserContext);

  // Add these with your other state declarations
  const [scanningModeOptions, setScanningModeOptions] = useState([]);
  const [selectedScanningMode, setSelectedScanningMode] = useState(null);

  const [isMultipleScheme, setIsMultipleScheme] = useState(false);
  const [updateButtondisabled, setUpdateButtondisabled] = useState(false);

  const [formData, setFormData] = useState({
    userId: UM_UserId,
    CC_CM_ID: "",
    CC_CMType: "",
    CC_Maxplant: "",
    CC_Maxproduct: "",
    CC_RSNcutOffRequest: "",
    CC_RSNRequestConf: "",
    CC_SSCCRequestConf: "",
    CC_IsMultipleScheme: 0,
    CC_ScanningMode: "",
    CC_IsMaximumUserDefined: 1,
    CC_IsRSNLimitDefined: 1,
    CC_NoOfUser: "",
    CC_UserLimitExceedAction: "",
    CC_NoOfRSN: "",
    CC_RSNLimitExceedAction: "",
    CC_PackingLevelForShipment: Infinity,
    selectedtandt: [],
    fieldVal: [],
    packinglevel: [],
    CC_IsMappingBypassed: "",
    // New form fields
    CC_CompanyLogo: "",
    CC_DateFormat: 8,
    companyChannels: [],
    companyEventTypes: []
  });

  const navigate = useNavigate();
  // const id = sessionStorage.getItem("CC_ID");
  const { id } = useParams();
  console.log("id", id)
  const [storedRights, setStoredRights] = useState([]);
  const singleChildRef = useRef(new Map());
  const [errMsg, setErrMsg] = useState({});
  const [selectedDate, setSelectedDate] = useState(null);
  const [companyconfig, setCompanyConfig] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [logoPreview, setLogoPreview] = useState(null);
  const [loadingEventTypes, setLoadingEventTypes] = useState(false);

  const toastRef = useRef(null);
  const showToast = (type, message, options = {}) => {
    if (toastRef.current && toast.isActive(toastRef.current)) {
      toast.update(toastRef.current, {
        render: message,
        type,
        autoClose: 3000,
        ...options,
      });
    } else {
      toastRef.current = toast[type](message, {
        autoClose: 3000,
        ...options,
      });
    }
  };

  // Function to get checked keys as an array
  const getCheckedKeysArray = () => {
    if (!selectedKeys) return [];
    return Object.keys(selectedKeys).filter(
      (key) => selectedKeys[key]?.checked === true
    );
  };

  const treeData = nodes.map((parent) => ({
    key: parent.key,
    title: parent.label,
    disabled: parent.disabled,
    children: parent.children?.map((child) => ({
      key: child.key,
      title: child.label,
      disabled: child.disabled,
    })),
  }));

  const parentMap = useRef(new Map());
  const childrenMap = useRef(new Map());

  useEffect(() => {
    const pMap = new Map();
    const cMap = new Map();

    treeData.forEach(menu => {
      if (menu.children?.length) {
        cMap.set(menu.key, menu.children.map(c => c.key));
        menu.children.forEach(sub => {
          pMap.set(sub.key, menu.key);
        });
      }
    });

    parentMap.current = pMap;
    childrenMap.current = cMap;
  }, [treeData]);

  console.log("Tree-------------", treeData)

  const buildCheckedState = (checkedSet) => {
    const result = {};

    // First mark all checked items (children and parents that are directly checked)
    checkedSet.forEach(key => {
      result[key] = { checked: true, partialChecked: false };
    });

    // Now handle parent partial states
    childrenMap.current.forEach((children, parent) => {
      // Count how many children are in the checked set
      const checkedChildren = children.filter(c => checkedSet.has(c));

      // Count total children (excluding any logic for disabled if needed)
      const totalChildren = children.length;

      if (checkedChildren.length > 0) {
        if (checkedChildren.length === totalChildren) {
          // ALL children are checked → parent should be fully checked
          result[parent] = { checked: true, partialChecked: false };
        } else {
          // SOME children are checked → parent should be partial/indeterminate
          result[parent] = { checked: false, partialChecked: true };
        }
      } else {
        // NO children are checked → remove parent if it exists (unchecked state)
        delete result[parent];
      }
    });

    return result;
  };
  const handleCheck = (checkedKeysValue, info) => {
    const rawChecked = checkedKeysValue?.checked || [];
    const newChecked = new Set(rawChecked);
    const prevChecked = new Set(Object.keys(selectedKeys || {}));

    const clickedKey = info?.node?.key;
    const isChecked = info?.checked;

    // 🔹 If submenu checked → auto-check parent
    if (isChecked && parentMap.current.has(clickedKey)) {
      newChecked.add(parentMap.current.get(clickedKey));
    }

    // 🔹 If menu checked → auto-check all submenus
    if (isChecked && childrenMap.current.has(clickedKey)) {
      childrenMap.current.get(clickedKey).forEach(child =>
        newChecked.add(child)
      );
    }

    // 🔹 If menu unchecked → uncheck all submenus
    if (!isChecked && childrenMap.current.has(clickedKey)) {
      childrenMap.current.get(clickedKey).forEach(child =>
        newChecked.delete(child)
      );
    }

    // 🔹 If submenu unchecked → uncheck parent ONLY if no sibling checked
    if (!isChecked && parentMap.current.has(clickedKey)) {
      const parent = parentMap.current.get(clickedKey);
      const siblings = childrenMap.current.get(parent) || [];
      const anySiblingChecked = siblings.some(sib => newChecked.has(sib));
      if (!anySiblingChecked) {
        newChecked.delete(parent);
      }
    }

    // 🔹 Force required keys
    disabledKeys.forEach(key => newChecked.add(key));

    const updated = buildCheckedState(newChecked);

    // 👉 NEW LOGIC: Check if "Message Configuration" (2-3) is being unchecked
    const messageConfigKey = "2-3";
    const wasMessageConfigSelected = selectedKeys && selectedKeys[messageConfigKey]?.checked;
    const isMessageConfigSelected = updated[messageConfigKey]?.checked;

    // If Message Configuration was selected before but is now being unchecked
    if (wasMessageConfigSelected && !isMessageConfigSelected) {
      // Clear company channels and event types
      setSelectedCompanyChannels([]);
      setSelectedCompanyEventTypes([]);
      setCompanyEventTypeOptions([]);

      // Clear from formData
      setFormData(prev => ({
        ...prev,
        companyChannels: [],
        companyEventTypes: []
      }));
    }

    setSelectedKeys(updated);
    setFormData(prev => ({
      ...prev,
      selectRights: updated,
    }));

  };

  // Update the resetForm function - add this in the CREATE MODE section
  const resetForm = async () => {
    if (id) {
      // EDIT MODE → Reset everything except Company Name
      try {
        setIsLoading(true);

        const updateRes = await axios.get(`${config.API_URL}/getsingleconfiguration/${id}`);
        const data = updateRes.data.data;

        // Keep ONLY company name from backend → reset all others
        setFormData((prev) => ({
          ...prev,
          CC_CM_ID: data.CC_CM_ID,         // ✅ Keep company name
          CC_CMType: "",                   // Reset
          CC_IsMaximumUserDefined: 1,
          CC_NoOfUser: "",
          CC_UserLimitExceedAction: "",
          CC_IsRSNLimitDefined: 1,
          CC_NoOfRSN: "",
          CC_RSNLimitExceedAction: "",
          CC_PackingLevelForShipment: Infinity,
          CC_Maxplant: "",
          CC_Maxproduct: "",
          CC_RSNcutOffRequest: null,
          CC_RSNRequestConf: "",
          CC_SSCCRequestConf: "",
          CC_IsMappingBypassed: "",
          CC_CompanyLogo: "",
          CC_DateFormat: 8, // Set default date format on reset
          companyChannels: [],
          companyEventTypes: [],
          CC_IsMultipleScheme: 0,
          CC_ScanningMode: "",
          packinglevel: packingOption.map((item) => {
            // Find existing packing level data if it exists
            const existingPacking = formData.packinglevel?.find(
              p => p.CPLM_PLM_ID === item.PLM_ID
            );

            return {
              CPLM_PLM_ID: item.PLM_ID,
              CPLM_Name: existingPacking?.CPLM_Name || item.PLM_Name || "",
              CPLM_PackingLevelValue: item.PLM_PackingLevelValue,
            };
          }),
          fieldVal: (() => {
            const groupedFields = {};
            fieldOption.forEach((item) => {
              const key = `${item.ModuleName}_${item.IsMasterField}`;
              if (!groupedFields[key]) {
                groupedFields[key] = [];
              }
              groupedFields[key].push({
                CFLC_FieldID: item.FieldID,
                CFLC_DisplayName: item.FieldName,
                CFLC_ModuleName: item.ModuleName,
                CFLC_IsRequired: 1,
                CFLC_Order: groupedFields[key].length + 1,
              });
            });
            return Object.values(groupedFields).flat();
          })(),
          selectedtandt: [],
          // ADD THIS - Clear user rights
          selectRights: {}
        }));

        // Reset user rights completely
        setSelectedKeys(null);
        setStoredRights([]);

        // Also reset the selected date format UI
        const defaultDateFormat = dateFormatOptions.find(item => item.CC_DM_ID === 8);
        if (defaultDateFormat) {
          setSelectedDateFormat({
            value: defaultDateFormat.CC_DM_ID,
            label: defaultDateFormat.CC_DM_DateFormat
          });
        }

        // Reset UI states
        setSelectedType(null);
        setIsMaxUser(true);
        setIsMaxRSN(true);
        setSelectedCompanyChannels([]);
        setSelectedCompanyEventTypes([]);
        setCompanyEventTypeOptions([]);
        setLogoPreview(null);
        setErrMsg({});
        setIsMultipleScheme(false);
        setSelectedScanningMode(null);

        // Clear all user rights related state
        setNodes([]);
        setSelectedScanningModes([]);

      } catch (error) {
        console.error("[CCHome] resetForm error", error);
        showToast('error', "Failed to reset form. Please try again.");
      } finally {
        setIsLoading(false);
      }
    } else {
      // CREATE MODE → Keep your existing create-mode logic
      setFormData((prev) => ({
        ...prev,
        fieldVal: (() => {
          const groupedFields = {};
          fieldOption.forEach((item) => {
            const key = `${item.ModuleName}_${item.IsMasterField}`;
            if (!groupedFields[key]) {
              groupedFields[key] = [];
            }
            groupedFields[key].push({
              CFLC_FieldID: item.FieldID,
              CFLC_DisplayName: item.FieldName,
              CFLC_ModuleName: item.ModuleName,
              CFLC_IsRequired: 1,
              CFLC_Order: groupedFields[key].length + 1,
            });
          });
          return Object.values(groupedFields).flat();
        })(),
        packinglevel: packingOption.map((item) => {
          // Find existing packing level data if it exists
          const existingPacking = prev.packinglevel?.find(
            p => p.CPLM_PLM_ID === item.PLM_ID
          );

          return {
            CPLM_PLM_ID: item.PLM_ID,
            CPLM_Name: existingPacking?.CPLM_Name || item.PLM_Name || "",
            CPLM_PackingLevelValue: item.PLM_PackingLevelValue,
          };
        }),
        CC_IsMaximumUserDefined: 1,
        CC_IsRSNLimitDefined: 1,
        selectedtandt: [],
        CC_UserLimitExceedAction: "",
        CC_RSNLimitExceedAction: "",
        CC_NoOfUser: "",
        CC_NoOfRSN: "",
        CC_CMType: "",
        CC_CM_ID: "",
        CC_Maxplant: "",
        CC_Maxproduct: "",
        CC_RSNcutOffRequest: null,
        CC_PackingLevelForShipment: Infinity,
        CC_RSNRequestConf: "",
        CC_SSCCRequestConf: "",
        CC_IsMappingBypassed: "",
        CC_CompanyLogo: "",
        CC_DateFormat: 8,
        companyChannels: [],
        companyEventTypes: [],
        CC_IsMultipleScheme: 0,
        CC_ScanningMode: "",
        // ADD THIS - Clear user rights
        selectRights: {}
      }));

      // Also reset the selected date format UI
      const defaultDateFormat = dateFormatOptions.find(item => item.CC_DM_ID === 8);
      if (defaultDateFormat) {
        setSelectedDateFormat({
          value: defaultDateFormat.CC_DM_ID,
          label: defaultDateFormat.CC_DM_DateFormat
        });
      }

      setSelectedType(null);
      setIsMaxRSN(true);
      setIsMaxUser(true);
      setErrMsg({});
      setLogoPreview(null);
      setSelectedCompanyChannels([]);
      setSelectedCompanyEventTypes([]);
      setCompanyEventTypeOptions([]);

      // Clear all user rights
      setSelectedKeys(null);
      setStoredRights([]);
      setNodes([]);
      setSelectedScanningModes([]);
    }
  };

  useEffect(() => {
    // When id becomes null (CC_ID removed from sessionStorage), reset the form
    if (!id) {
      resetForm();
    }
  }, [id]);

  // Validate positive integer strings
  const isPositiveIntegerString = (raw) => {
    if (raw === null || raw === undefined) return false;
    const s = String(raw).trim();
    if (s === "") return false;
    if (!/^\d+$/.test(s)) return false;
    return parseInt(s, 10) > 0;
  };

  // Handler for date format selection
  const handleDateFormatChange = (selectedOption) => {
    setSelectedDateFormat(selectedOption);
    setFormData(prev => ({
      ...prev,
      CC_DateFormat: selectedOption?.value || ""
    }));
    validateField("CC_DateFormat", selectedOption?.value);
  };

  // Handler for company channel selection
  const handleCompanyChannelChange = (e, channel) => {
    const isChecked = e.target.checked;
    const channelValue = channel.EnumVal.toString();

    let updatedChannels;

    if (isChecked) {
      updatedChannels = [...selectedCompanyChannels, channelValue];
    } else {
      updatedChannels = selectedCompanyChannels.filter(id => id !== channelValue);
    }

    setSelectedCompanyChannels(updatedChannels);
    setFormData(prev => ({
      ...prev,
      companyChannels: updatedChannels
    }));

    // Clear channel validation error when user interacts
    setErrMsg(prev => {
      const newErrors = { ...prev };
      delete newErrors.companyChannels;
      return newErrors;
    });

    // Clear event types if no channels selected
    if (updatedChannels.length === 0) {
      setSelectedCompanyEventTypes([]);
      setFormData(prev => ({
        ...prev,
        companyEventTypes: []
      }));
      setCompanyEventTypeOptions([]);

      // Also clear event type validation error
      setErrMsg(prev => {
        const newErrors = { ...prev };
        delete newErrors.companyEventTypes;
        return newErrors;
      });
    } else if (selectedType) {
      // Fetch event types when channels change
      fetchCompanyEventTypes();
    }
  };

  // Update handleCompanyEventTypeChange to clear errors
  const handleCompanyEventTypeChange = (e, eventType) => {
    const isChecked = e.target.checked;
    const eventTypeId = eventType.EEVM_EmailEventId.toString();

    let updatedEventTypes;

    if (isChecked) {
      updatedEventTypes = [...selectedCompanyEventTypes, eventTypeId];
    } else {
      updatedEventTypes = selectedCompanyEventTypes.filter(id => id !== eventTypeId);
    }

    setSelectedCompanyEventTypes(updatedEventTypes);
    setFormData(prev => ({
      ...prev,
      companyEventTypes: updatedEventTypes
    }));

    // Clear event type validation error when user interacts
    setErrMsg(prev => {
      const newErrors = { ...prev };
      delete newErrors.companyEventTypes;
      return newErrors;
    });
  };

  // Also update toggleSelectAllEventTypes
  const toggleSelectAllEventTypes = () => {
    if (isAllEventTypesSelected()) {
      // Deselect all
      setSelectedCompanyEventTypes([]);
      setFormData(prev => ({
        ...prev,
        companyEventTypes: []
      }));
    } else {
      // Select all
      const allEventTypeIds = companyEventTypeOptions.map(eventType =>
        eventType.EEVM_EmailEventId.toString()
      );
      setSelectedCompanyEventTypes(allEventTypeIds);
      setFormData(prev => ({
        ...prev,
        companyEventTypes: allEventTypeIds
      }));
    }

    // Clear event type validation error when user interacts
    setErrMsg(prev => {
      const newErrors = { ...prev };
      delete newErrors.companyEventTypes;
      return newErrors;
    });
  };

  // Function to fetch company event types when channels are selected
  const fetchCompanyEventTypes = async () => {
    if (!selectedType) return;

    try {
      setLoadingEventTypes(true);
      const eventTypeRes = await axios.post(
        `${config.API_URL}/companyeventtypes`,
        { selectedType }
      );

      setCompanyEventTypeOptions(eventTypeRes.data.data || []);
      setLoadingEventTypes(false);

    } catch (error) {
      console.error("Error fetching event types:", error);
      setLoadingEventTypes(false);
      showToast('error', "Failed to load event types");
    }
  };

  // Check if all event types are selected
  const isAllEventTypesSelected = () => {
    if (companyEventTypeOptions.length === 0) return false;
    return companyEventTypeOptions.every(eventType =>
      selectedCompanyEventTypes.includes(eventType.EEVM_EmailEventId.toString())
    );
  };

  // Check if some event types are selected (for partial selection state if needed)
  const isSomeEventTypesSelected = () => {
    if (companyEventTypeOptions.length === 0) return false;
    return selectedCompanyEventTypes.length > 0 &&
      selectedCompanyEventTypes.length < companyEventTypeOptions.length;
  };

  //====================================================================================
  // Function to check if new fields should be shown
  // Function to check if new fields should be shown
  const shouldShowSchemeAndScanningFields = () => {
    // Log for debugging
    console.log("Checking conditions for scheme/scanning fields:");
    console.log("CC_CMType:", formData.CC_CMType);
    console.log("selectedKeys:", selectedKeys);

    // Condition 1: Company type is 3(SCP) or 1(Both)
    // Convert to number for comparison
    const companyType = Number(formData.CC_CMType);
    if (companyType !== 1 && companyType !== 3) {
      console.log("Condition 1 failed: Company type not 1 or 3");
      return false;
    }

    // Condition 2: Scheme Master is checked in user rights
    const isSchemeMasterChecked = selectedKeys && selectedKeys["1-17"]?.checked;
    if (!isSchemeMasterChecked) {
      console.log("Condition 2 failed: Scheme Master not checked");
      return false;
    }

    // Condition 3: Any one is checked from Order (Order Master (by SCP), Order Master (by Sales Officer))
    const isOrderMasterSCPChecked = selectedKeys && selectedKeys["3-1"]?.checked;
    const isOrderMasterSalesOfficerChecked = selectedKeys && selectedKeys["3-2"]?.checked;

    if (!isOrderMasterSCPChecked && !isOrderMasterSalesOfficerChecked) {
      console.log("Condition 3 failed: No Order Master checked");
      return false;
    }

    console.log("All conditions met, showing fields");
    return true;
  };

  // Handler for Multiple Scheme switch
  const handleMultipleSchemeChange = (event) => {
    const isChecked = event.target.checked;
    setIsMultipleScheme(isChecked);
    setFormData(prev => ({
      ...prev,
      CC_IsMultipleScheme: isChecked ? 1 : 0
    }));
  };

  // Handler for Scanning Mode dropdown
  // const handleScanningModeChange = (selectedOption) => {
  //   setSelectedScanningMode(selectedOption);
  //   // Store only the value (ID) in formData, not the whole object
  //   setFormData(prev => ({
  //     ...prev,
  //     CC_ScanningMode: selectedOption?.value || ""
  //   }));
  //   // Clear validation error
  //   setErrMsg(prev => {
  //     const newErrors = { ...prev };
  //     delete newErrors.CC_ScanningMode;
  //     return newErrors;
  //   });
  // };
  // Replace the scanning mode state
  const [selectedScanningModes, setSelectedScanningModes] = useState([]);

  // Replace the handler with checkbox logic
  const handleScanningModeChange = (modeValue, isChecked) => {
    let updatedModes;

    if (modeValue === 3) { // "Select All"
      if (isChecked) {
        // Select all including "Select All", Vendor, and Product
        updatedModes = [3, 1, 2];
      } else {
        // Unselect all
        updatedModes = [];
      }
    } else {
      // For Vendor (1) or Product (2)
      const currentModes = selectedScanningModes || [];

      if (isChecked) {
        // Add the mode
        updatedModes = [...new Set([...currentModes, modeValue])];

        // If both Vendor and Product are selected, also add "Select All"
        const hasVendor = updatedModes.includes(1);
        const hasProduct = updatedModes.includes(2);
        if (hasVendor && hasProduct && !updatedModes.includes(3)) {
          updatedModes = [...updatedModes, 3];
        }
      } else {
        // Remove the mode
        updatedModes = currentModes.filter(mode => mode !== modeValue);

        // If deselecting one, also remove "Select All" if it exists
        updatedModes = updatedModes.filter(mode => mode !== 3);
      }
    }

    setSelectedScanningModes(updatedModes);

    // Determine what value to save in database based on business logic
    let dbValue;
    if (updatedModes.includes(3)) {
      // If "Select All" is checked, save value 3
      dbValue = 3;
    } else if (updatedModes.includes(1) && !updatedModes.includes(2)) {
      // Only Vendor checked
      dbValue = 1;
    } else if (updatedModes.includes(2) && !updatedModes.includes(1)) {
      // Only Product checked
      dbValue = 2;
    } else if (updatedModes.includes(1) && updatedModes.includes(2)) {
      // Both Vendor and Product checked (but "Select All" not explicitly checked)
      dbValue = 3; // This might be your business logic
    } else {
      dbValue = ""; // None selected
    }

    setFormData(prev => ({
      ...prev,
      CC_ScanningMode: dbValue
    }));

    // Clear validation error
    setErrMsg(prev => {
      const newErrors = { ...prev };
      delete newErrors.CC_ScanningMode;
      return newErrors;
    });
  };

  // Helper function to check if all are selected
  const isAllSelected = () => {
    return selectedScanningModes.includes(1) &&
      selectedScanningModes.includes(2) &&
      selectedScanningModes.includes(3);
  };

  // Helper function to check individual modes
  const isVendorSelected = () => selectedScanningModes.includes(1);
  const isProductSelected = () => selectedScanningModes.includes(2);

  // Function to fetch configured companies
  const fetchConfiguredCompanies = async () => {
    try {
      const response = await axios.get(`${config.API_URL}/getConfiguredCompanies`);

      if (response.data.success) {
        setConfiguredCompanyIds(response.data.data || []);
      }
    } catch (error) {
      console.error("Error fetching configured companies:", error);
      showToast('error', "Failed to load configured companies data");
    }
  };

  // Modify company options to disable already configured ones (except in edit mode)
  const getFilteredCompanyOptions = () => {
    if (!companyOptions || companyOptions.length === 0) return [];

    // If in edit mode, don't disable any companies
    if (id) {
      return companyOptions;
    }

    // In create mode, disable already configured companies
    return companyOptions.map(company => ({
      ...company,
      isDisabled: configuredCompanyIds.includes(company.CM_ID)
    }));
  };

  // const handleChange = (selectedCompanyType) => {
  //   // Convert to string for consistent comparison
  //   const selectedTypeStr = selectedCompanyType?.toString();

  //   // Determine new selected type based on current selection
  //   let newSelectedType;

  //   if (selectedCompanyType === 1) {
  //     // If "Select All" is clicked
  //     if (selectedType === 1) {
  //       // If it's already selected, unselect it
  //       newSelectedType = null;
  //     } else {
  //       // Otherwise, select it
  //       newSelectedType = 1;
  //     }
  //   } else if (selectedCompanyType === 2 || selectedCompanyType === 3) {
  //     // If Production or SCP is clicked
  //     if (selectedType === selectedCompanyType) {
  //       // If it's already selected, unselect it
  //       newSelectedType = null;
  //     } else if (selectedType === 1) {
  //       // If "Select All" is currently selected
  //       if (selectedCompanyType === 2) {
  //         // User clicked Production while "Select All" is selected
  //         // This should keep only SCP selected
  //         newSelectedType = 3;
  //       } else if (selectedCompanyType === 3) {
  //         // User clicked SCP while "Select All" is selected
  //         // This should keep only Production selected
  //         newSelectedType = 2;
  //       }
  //     } else if (selectedCompanyType === 2 && selectedType === 3) {
  //       // Production clicked while SCP is selected → select both (Select All)
  //       newSelectedType = 1;
  //     } else if (selectedCompanyType === 3 && selectedType === 2) {
  //       // SCP clicked while Production is selected → select both (Select All)
  //       newSelectedType = 1;
  //     } else {
  //       // Select the clicked type
  //       newSelectedType = selectedCompanyType;
  //     }
  //   }

  //   // Set the selected type
  //   setSelectedType(newSelectedType);

  //   // Convert to string for consistent comparison
  //   const newTypeStr = newSelectedType?.toString();

  //   // CRITICAL FIX: Clear stored rights when company type changes
  //   setStoredRights([]);

  //   // Reset all input fields and states based on the new company type
  //   // Reset company channels and event types
  //   setSelectedCompanyChannels([]);
  //   setSelectedCompanyEventTypes([]);
  //   setCompanyEventTypeOptions([]);

  //   // Reset user rights
  //   setSelectedKeys(null);
  //   setNodes([]);

  //   // Reset RSN limit based on company type
  //   if (newTypeStr !== '3') {
  //     setIsMaxRSN(true);
  //     setFormData(prev => ({
  //       ...prev,
  //       CC_IsRSNLimitDefined: 1,
  //     }));
  //   } else {
  //     setIsMaxRSN(false);
  //     setFormData(prev => ({
  //       ...prev,
  //       CC_IsRSNLimitDefined: 0,
  //     }));
  //   }

  //   // Reset form data comprehensively
  //   setFormData((prev) => ({
  //     ...prev,
  //     // Company type - store the new selected value
  //     CC_CMType: newSelectedType || "",

  //     // Reset all production-related fields (for Production/Both)
  //     CC_Maxplant: "",
  //     CC_Maxproduct: "",
  //     CC_RSNcutOffRequest: "",
  //     CC_RSNRequestConf: "",
  //     CC_SSCCRequestConf: "",
  //     CC_IsMappingBypassed: "",
  //     CC_PackingLevelForShipment: Infinity,

  //     // Reset user limits
  //     CC_NoOfUser: "",
  //     CC_UserLimitExceedAction: "",

  //     // Reset RSN limits
  //     CC_NoOfRSN: "",
  //     CC_RSNLimitExceedAction: "",

  //     // Reset user rights
  //     selectRights: {},

  //     // Reset packing level
  //     packinglevel: newTypeStr === '3'
  //       ? []
  //       : (packingOption || []).map((item) => ({
  //         CPLM_PLM_ID: item.PLM_ID,
  //         CPLM_Name: item.PLM_Name || '',
  //         CPLM_PackingLevelValue: item.PLM_PackingLevelValue,
  //       })),

  //     // Reset field values
  //     fieldVal: (() => {
  //       const groupedFields = {};
  //       fieldOption.forEach((item) => {
  //         const key = `${item.ModuleName}_${item.IsMasterField}`;
  //         if (!groupedFields[key]) {
  //           groupedFields[key] = [];
  //         }
  //         groupedFields[key].push({
  //           CFLC_FieldID: item.FieldID,
  //           CFLC_DisplayName: item.FieldName,
  //           CFLC_ModuleName: item.ModuleName,
  //           CFLC_IsRequired: 1,
  //           CFLC_Order: groupedFields[key].length + 1,
  //         });
  //       });
  //       return Object.values(groupedFields).flat();
  //     })(),

  //     // Reset T&T regulatory
  //     selectedtandt: [],

  //     // Reset new fields
  //     CC_CompanyLogo: "",
  //     companyChannels: [],
  //     companyEventTypes: [],

  //     // Reset RSN limit definition
  //     CC_IsRSNLimitDefined: newTypeStr === '3' ? 0 : 1,
  //   }));

  //   // Clear error messages
  //   setErrMsg({});

  //   // IMPORTANT: Don't try to filter rights if no company type is selected
  //   if (newSelectedType !== null) {
  //     // Since we cleared storedRights, create an empty set
  //     const selectedRightKeys = new Set();

  //     const isSubMenuAllowed = (subMenu, companyType) => {
  //       // Your existing isSubMenuAllowed logic...
  //       // Keep your existing isSubMenuAllowed function
  //       const allowedRoles = Array.isArray(subMenu.SMNM_AllowedRoles)
  //         ? subMenu.SMNM_AllowedRoles.map(Number)
  //         : typeof subMenu.SMNM_AllowedRoles === "string"
  //           ? subMenu.SMNM_AllowedRoles.split(",").map(r => Number(r.trim()))
  //           : [];

  //       const rightType = Number(subMenu.SMNM_RightType);

  //       // 🔹 Company Type = 1 (Select All / Both) - Show all rights
  //       if (companyType === 1) return true;

  //       // 🔹 Case: [2,3] or [3,2] → allow EVERYTHING
  //       if (
  //         allowedRoles.length === 2 &&
  //         allowedRoles.includes(2) &&
  //         allowedRoles.includes(3)
  //       ) {
  //         return true;
  //       }

  //       // 🔹 Case: Allowed for ALL [0]
  //       if (allowedRoles.includes(0)) {
  //         return rightType === 1 || rightType === companyType;
  //       }

  //       // 🔹 Case: Only selected company type [2] or [3]
  //       if (
  //         allowedRoles.length === 1 &&
  //         allowedRoles.includes(companyType)
  //       ) {
  //         return true;
  //       }

  //       // 🔹 Case: Only Admin [1]
  //       if (allowedRoles.length === 1 && allowedRoles.includes(1)) {
  //         return rightType === companyType;
  //       }

  //       // 🔹 Case: Mixed roles [1,2], [1,3], [1,2,3,0]
  //       if (allowedRoles.includes(companyType)) {
  //         return rightType === 1 || rightType === companyType;
  //       }

  //       return false;
  //     };

  //     const filteredMenus = () => {
  //       return rightVal
  //         .map((menuItem) => {
  //           const filteredSubMenus = menuItem.SubMenus.filter((subMenu) => {
  //             return isSubMenuAllowed(subMenu, newSelectedType);
  //           });

  //           return {
  //             ...menuItem,
  //             SubMenus: filteredSubMenus,
  //           };
  //         })
  //         .filter((menuItem) => menuItem.SubMenus.length > 0);
  //     };

  //     const filtered = filteredMenus();
  //     const keyObj = {};
  //     const disabledKeySet = new Set();
  //     singleChildRef.current = new Map();

  //     const menu = filtered.map((item) => {
  //       let disableParent = false;

  //       const children = item.SubMenus.map((child) => {
  //         const key = `${child.SMNM_MenuID}-${child.SMNM_SubMenuIndex}`;
  //         const isRequired = child.SMNM_IsRequired === 1;
  //         const isSelected = selectedRightKeys.has(key);

  //         if (isRequired || isSelected) {
  //           keyObj[key] = { checked: true, partialChecked: false };
  //         }

  //         if (isRequired) {
  //           disabledKeySet.add(key);
  //           disableParent = true;
  //         }

  //         return {
  //           key,
  //           label: child.SMNM_SubMenuDisplay,
  //           disabled: isRequired,
  //         };
  //       });

  //       const parentKey = item.MNM_MenuID.toString();
  //       const hasSelectedChild = children.some((child) =>
  //         selectedRightKeys.has(child.key)
  //       );

  //       if (disableParent || hasSelectedChild) {
  //         keyObj[parentKey] = { checked: true, partialChecked: false };
  //       }

  //       if (disableParent) {
  //         disabledKeySet.add(parentKey);
  //       }

  //       return {
  //         key: parentKey,
  //         label: item.MNM_MenuName,
  //         children: children,
  //         disabled: disableParent,
  //       };
  //     });

  //     // Create a Set of all selected child keys
  //     const allSelectedKeys = new Set();

  //     // Add all child keys that are selected (from keyObj)
  //     Object.keys(keyObj).forEach(key => {
  //       // Only add if it's a child key (contains dash) or if it's a parent that should be considered
  //       if (key.includes('-')) {
  //         allSelectedKeys.add(key);
  //       }
  //     });

  //     // Add disabled keys
  //     disabledKeySet.forEach(key => allSelectedKeys.add(key));

  //     // Build proper checked state with partial parents
  //     const properSelectedKeys = buildCheckedState(allSelectedKeys);

  //     setSelectedKeys(properSelectedKeys);
  //     setDisabledKeys(disabledKeySet);
  //     setNodes(menu);
  //   } else {
  //     // If no company type is selected, clear everything
  //     setSelectedKeys(null);
  //     setNodes([]);
  //   }

  //   // Re-validate company type field
  //   validateField("CC_CMType", newSelectedType);
  // };
  const handleChange = (selectedCompanyType) => {
    // Convert to string for consistent comparison
    const selectedTypeStr = selectedCompanyType?.toString();

    // Determine new selected type based on current selection
    let newSelectedType;

    if (selectedCompanyType === 1) {
      // If "Select All" is clicked
      if (selectedType === 1) {
        // If it's already selected, unselect it
        newSelectedType = null;
      } else {
        // Otherwise, select it
        newSelectedType = 1;
      }
    } else if (selectedCompanyType === 2 || selectedCompanyType === 3) {
      // If Production or SCP is clicked
      if (selectedType === selectedCompanyType) {
        // If it's already selected, unselect it
        newSelectedType = null;
      } else if (selectedType === 1) {
        // If "Select All" is currently selected
        if (selectedCompanyType === 2) {
          // User clicked Production while "Select All" is selected
          // This should keep only SCP selected
          newSelectedType = 3;
        } else if (selectedCompanyType === 3) {
          // User clicked SCP while "Select All" is selected
          // This should keep only Production selected
          newSelectedType = 2;
        }
      } else if (selectedCompanyType === 2 && selectedType === 3) {
        // Production clicked while SCP is selected → select both (Select All)
        newSelectedType = 1;
      } else if (selectedCompanyType === 3 && selectedType === 2) {
        // SCP clicked while Production is selected → select both (Select All)
        newSelectedType = 1;
      } else {
        // Select the clicked type
        newSelectedType = selectedCompanyType;
      }
    }

    // Set the selected type
    setSelectedType(newSelectedType);

    // Convert to string for consistent comparison
    const newTypeStr = newSelectedType?.toString();

    // CRITICAL FIX: Clear stored rights when company type changes
    setStoredRights([]);

    // Reset all input fields and states based on the new company type
    // Reset company channels and event types
    setSelectedCompanyChannels([]);
    setSelectedCompanyEventTypes([]);
    setCompanyEventTypeOptions([]);

    // Reset user rights
    setSelectedKeys(null);
    setNodes([]);

    // Reset RSN limit based on company type
    if (newTypeStr !== '3') {
      setIsMaxRSN(true);
      setFormData(prev => ({
        ...prev,
        CC_IsRSNLimitDefined: 1,
      }));
    } else {
      setIsMaxRSN(false);
      setFormData(prev => ({
        ...prev,
        CC_IsRSNLimitDefined: 0,
      }));
    }

    // Reset form data comprehensively
    setFormData((prev) => ({
      ...prev,
      // Company type - store the new selected value
      CC_CMType: newSelectedType || "",

      // Reset all production-related fields (for Production/Both)
      CC_Maxplant: "",
      CC_Maxproduct: "",
      CC_RSNcutOffRequest: "",
      CC_RSNRequestConf: "",
      CC_SSCCRequestConf: "",
      CC_IsMappingBypassed: "",
      CC_PackingLevelForShipment: Infinity,

      // Reset user limits
      CC_NoOfUser: "",
      CC_UserLimitExceedAction: "",

      // Reset RSN limits
      CC_NoOfRSN: "",
      CC_RSNLimitExceedAction: "",

      // Reset user rights
      selectRights: {},

      // Reset packing level
      packinglevel: newTypeStr === '3'
        ? []
        : (packingOption || []).map((item) => ({
          CPLM_PLM_ID: item.PLM_ID,
          CPLM_Name: item.PLM_Name || '',
          CPLM_PackingLevelValue: item.PLM_PackingLevelValue,
        })),

      // Reset field values
      fieldVal: (() => {
        const groupedFields = {};
        fieldOption.forEach((item) => {
          const key = `${item.ModuleName}_${item.IsMasterField}`;
          if (!groupedFields[key]) {
            groupedFields[key] = [];
          }
          groupedFields[key].push({
            CFLC_FieldID: item.FieldID,
            CFLC_DisplayName: item.FieldName,
            CFLC_ModuleName: item.ModuleName,
            CFLC_IsRequired: 1,
            CFLC_Order: groupedFields[key].length + 1,
          });
        });
        return Object.values(groupedFields).flat();
      })(),

      // Reset T&T regulatory
      selectedtandt: [],

      // Reset new fields
      CC_CompanyLogo: "",
      companyChannels: [],
      companyEventTypes: [],

      // Reset RSN limit definition
      CC_IsRSNLimitDefined: newTypeStr === '3' ? 0 : 1,
    }));

    // Clear error messages
    setErrMsg({});

    // IMPORTANT: Don't try to filter rights if no company type is selected
    if (newSelectedType !== null) {
      const isSubMenuAllowed = (subMenu, companyType) => {
        const allowedRoles = Array.isArray(subMenu.SMNM_AllowedRoles)
          ? subMenu.SMNM_AllowedRoles.map(Number)
          : typeof subMenu.SMNM_AllowedRoles === "string"
            ? subMenu.SMNM_AllowedRoles.split(",").map(r => Number(r.trim()))
            : [];

        const rightType = Number(subMenu.SMNM_RightType);

        // 🔹 Company Type = 1 (Select All / Both) - Show all rights
        if (companyType === 1) return true;

        // 🔹 Case: [2,3] or [3,2] → allow EVERYTHING
        if (
          allowedRoles.length === 2 &&
          allowedRoles.includes(2) &&
          allowedRoles.includes(3)
        ) {
          return true;
        }

        // 🔹 Case: Allowed for ALL [0]
        if (allowedRoles.includes(0)) {
          return rightType === 1 || rightType === companyType;
        }

        // 🔹 Case: Only selected company type [2] or [3]
        if (
          allowedRoles.length === 1 &&
          allowedRoles.includes(companyType)
        ) {
          return true;
        }

        // 🔹 Case: Only Admin [1]
        if (allowedRoles.length === 1 && allowedRoles.includes(1)) {
          return rightType === companyType;
        }

        // 🔹 Case: Mixed roles [1,2], [1,3], [1,2,3,0]
        if (allowedRoles.includes(companyType)) {
          return rightType === 1 || rightType === companyType;
        }

        return false;
      };

      const filteredMenus = () => {
        return rightVal
          .map((menuItem) => {
            const filteredSubMenus = menuItem.SubMenus.filter((subMenu) => {
              return isSubMenuAllowed(subMenu, newSelectedType);
            });

            return {
              ...menuItem,
              SubMenus: filteredSubMenus,
            };
          })
          .filter((menuItem) => menuItem.SubMenus.length > 0);
      };

      const filtered = filteredMenus();
      const disabledKeySet = new Set();
      singleChildRef.current = new Map();

      // Create the menu structure
      const menu = filtered.map((item) => {
        let disableParent = false;

        const children = item.SubMenus.map((child) => {
          const key = `${child.SMNM_MenuID}-${child.SMNM_SubMenuIndex}`;
          const isRequired = child.SMNM_IsRequired === 1;

          if (isRequired) {
            disabledKeySet.add(key);
            disableParent = true;
          }

          return {
            key,
            label: child.SMNM_SubMenuDisplay,
            disabled: isRequired,
          };
        });

        const parentKey = item.MNM_MenuID.toString();

        if (disableParent) {
          disabledKeySet.add(parentKey);
        }

        return {
          key: parentKey,
          label: item.MNM_MenuName,
          children: children,
          disabled: disableParent,
        };
      });

      // Set the menu first
      setNodes(menu);

      // Initialize the parent-child maps
      setTimeout(() => {
        // The maps should be updated by the useEffect that runs when treeData changes
        // Now create the initial selected keys set with disabled items
        const initialSelectedKeys = new Set();

        // Add all disabled keys (required items)
        disabledKeySet.forEach(key => {
          // Only add child keys, not parent keys
          if (key.includes('-')) {
            initialSelectedKeys.add(key);
          }
        });

        console.log("Initial selected child keys:", Array.from(initialSelectedKeys));

        // Build the proper checked state with parent partial states
        const properSelectedKeys = buildCheckedState(initialSelectedKeys);

        console.log("Proper selected keys with partial states:", properSelectedKeys);

        setSelectedKeys(properSelectedKeys);
        setDisabledKeys(disabledKeySet);
      }, 100); // Small timeout to ensure maps are populated

    } else {
      // If no company type is selected, clear everything
      setSelectedKeys(null);
      setNodes([]);
    }

    // Re-validate company type field
    validateField("CC_CMType", newSelectedType);
  };
  useEffect(() => {
    const fetchData = async () => {
      console.log("[CCHome] fetchData: start", { id });
      let safetyTimer;
      try {
        setIsLoading(true);
        safetyTimer = setTimeout(() => {
          console.warn("[CCHome] fetchData: safety timeout elapsed");
          setIsLoading(false);
        }, 15000);

        // Fetch configured companies first
        await fetchConfiguredCompanies();
        const res = await axios.get(`${config.API_URL}/prefetchdata`);
        const fetchedData = res.data.data;

        console.log("[CCHome] prefetchdata loaded", fetchedData);

        setCompanyOptions(fetchedData.getCompanyRes || []);
        setComType(fetchedData.getCompanyTypeRes || []);
        setUserLimitOption(fetchedData.getUserLimitTypeRes || []);
        setRightVal(fetchedData.companyRightRes || []);
        console.log("[CCHome] companyRightRes", fetchedData.companyRightRes);
        setRsnLimitOption(fetchedData.getRSNLimitTypeRes || []);
        setTndTOption(fetchedData.getTandTregulateryRes || []);
        setFieldOption(fetchedData.getFieldQueryRes || []);
        setPackingOption(fetchedData.getPackingLevel || []);
        setCompanyConfig(fetchedData.getCompanyConfigureRes || []);
        setScanningModeOptions(fetchedData.getScanningModeRes || []);

        // Fetch date formats
        try {
          const dateFormatRes = await axios.get(`${config.API_URL}/dateformats`);
          const dateFormats = dateFormatRes.data.data || [];
          setDateFormatOptions(dateFormats);

          // Set default date format (id=8: dd/MM/yyyy) in CREATE mode
          if (!id) {
            const defaultDateFormat = dateFormats.find(item => item.CC_DM_ID === 8);
            if (defaultDateFormat) {
              setSelectedDateFormat({
                value: defaultDateFormat.CC_DM_ID,
                label: defaultDateFormat.CC_DM_DateFormat
              });

              // Also update formData with the default value
              setFormData(prev => ({
                ...prev,
                CC_DateFormat: defaultDateFormat.CC_DM_ID
              }));
            }
          }
        } catch (error) {
          console.error("Error fetching date formats:", error);
        }

        // Fetch company channels
        try {
          const channelRes = await axios.get(`${config.API_URL}/companychannels`);
          setCompanyChannelOptions(channelRes.data.data || []);
        } catch (error) {
          console.error("Error fetching company medium:", error);
        }

        if (!id) {
          // CREATE MODE - Initialize form data
          setFormData((prev) => ({
            ...prev,
            fieldVal: (() => {
              const groupedFields = {};
              fetchedData.getFieldQueryRes?.forEach((item) => {
                const key = `${item.ModuleName}_${item.IsMasterField}`;
                if (!groupedFields[key]) {
                  groupedFields[key] = [];
                }
                groupedFields[key].push({
                  CFLC_FieldID: item.FieldID,
                  CFLC_DisplayName: item.FieldName,
                  CFLC_ModuleName: item.ModuleName,
                  CFLC_IsRequired: 1,
                  CFLC_Order: groupedFields[key].length + 1,
                });
              });
              return Object.values(groupedFields).flat();
            })(),
            packinglevel:
              fetchedData.getPackingLevel?.map((item) => ({
                CPLM_PLM_ID: item.PLM_ID,
                CPLM_Name: item.PLM_Name || "",
                CPLM_PackingLevelValue: item.PLM_PackingLevelValue,
              })) || [],
            CC_IsMaximumUserDefined: 1,
            CC_IsRSNLimitDefined: 1,
          }));
        } else {
          // EDIT MODE - Fetch single configuration data
          const updateRes = await axios.get(
            `${config.API_URL}/getsingleconfiguration/${id}`
          );
          const data = updateRes.data.data;
          console.log("[CCHome] getsingleconfiguration loaded edit data", data);
          console.log("Backend channel data:", data.channelDetails);
          console.log("Backend event types:", data.eventTypeDetails);
          console.log("Backend date format:", data.dateFormatDetails);
          console.log("Backend selected rights:", data.selectedrights);

          // Log the new fields specifically
          console.log("CC_IsMultipleScheme from API:", data.CC_IsMultipleScheme);
          console.log("CC_ScanningMode from API:", data.CC_ScanningMode);

          // Set form data from backend
          setFormData((prev) => ({
            ...prev,
            CC_CMType: data.CC_CMType,
            CC_CM_ID: data.CC_CM_ID,
            CC_IsMaximumUserDefined: data.CC_IsMaximumUserDefined,
            CC_NoOfUser: data.CC_NoOfUser,
            CC_UserLimitExceedAction: data.CC_UserLimitExceedAction,
            CC_IsRSNLimitDefined: data.CC_IsRSNLimitDefined,
            CC_NoOfRSN: data.CC_NoOfRSN,
            CC_RSNLimitExceedAction: data.CC_RSNLimitExceedAction,
            CC_PackingLevelForShipment: data.CC_PackingLevelForShipment === null ? Infinity : data.CC_PackingLevelForShipment,
            CC_Maxplant: data.CC_Maxplant,
            CC_Maxproduct: data.CC_Maxproduct,
            CC_RSNcutOffRequest: data.CC_RSNcutOffRequest,
            CC_RSNRequestConf: data.CC_RSNRequestConf,
            CC_SSCCRequestConf: data.CC_SSCCRequestConf,
            CC_IsMappingBypassed: data.CC_IsMappingBypassed,
            CC_IsMultipleScheme: data.CC_IsMultipleScheme || 0,
            CC_ScanningMode: data.CC_ScanningMode || "",
            CC_CompanyLogo: data.CC_CompanyLogo || "",
            CC_DateFormat: data.CC_DateFormat || 8,
            companyChannels: data.channelDetails?.map(channel => channel.ChannelValue.toString()) || [],
            companyEventTypes: data.eventTypeDetails?.map(event =>
              event.EEVM_EmailEventId?.toString() || event.ET_EventTypeValue?.toString()
            ) || [],
            packinglevel: data.packingleveres?.map((item) => ({
              CPLM_PLM_ID: item.CPLM_PLM_ID,
              CPLM_ID: item.CPLM_ID,
              CPLM_Name: item.CPLM_Name,
            })) || [],
            fieldVal: data.fieldnameres?.map((item) => ({
              CFLC_ID: item.CFLC_ID,
              CFLC_FieldID: item.CFLC_FieldID,
              CFLC_DisplayName: item.CFLC_DisplayName,
              CFLC_ModuleName: item.CFLC_ModuleName,
              CFLC_IsRequired: item.CFLC_IsRequired,
              CFLC_Order: item.CFLC_Order || null,
            })) || [],
            selectedtandt: data.tandtres?.map((item) => item.RCM_CountryID) || [],
          }));

          // FIX: Convert string to number for switch states
          const isMaxUserValue = Number(data.CC_IsMaximumUserDefined) === 1;
          const isMaxRSNValue = Number(data.CC_IsRSNLimitDefined) === 1;
          const isMultipleSchemeValue = Number(data.CC_IsMultipleScheme) === 1;
          setIsMaxUser(isMaxUserValue);
          setIsMaxRSN(isMaxRSNValue);
          setIsMultipleScheme(isMultipleSchemeValue);
          setSelectedType(data.CC_CMType);
          setScanningModeOptions(fetchedData.getScanningModeRes || []);

          // Update scanning mode handling in edit mode
          if (data.CC_ScanningMode) {
            const scanningModeValue = parseInt(data.CC_ScanningMode);
            let modesToSelect = [];

            if (scanningModeValue === 3) {
              modesToSelect = [3, 1, 2];
            } else if (scanningModeValue === 1) {
              modesToSelect = [1];
            } else if (scanningModeValue === 2) {
              modesToSelect = [2];
            }

            setSelectedScanningModes(modesToSelect);
          }

          // Handle date
          if (data.CC_RSNcutOffRequest) {
            const dateParts = data.CC_RSNcutOffRequest.split('-');
            if (dateParts.length === 3) {
              const [year, month, day] = dateParts;
              const formattedDate = new Date(`${year}-${month}-${day}`);
              setSelectedDate(formattedDate);
            }
          } else {
            setSelectedDate(null);
          }

          // Set date format from API response
          if (data.dateFormatDetails) {
            setSelectedDateFormat({
              value: data.dateFormatDetails.CC_DM_ID,
              label: data.dateFormatDetails.CC_DM_DateFormat
            });
          } else {
            const dateFormats = dateFormatOptions.length > 0 ? dateFormatOptions : await fetchDateFormats();
            const defaultDateFormat = dateFormats.find(item => item.CC_DM_ID === 8);
            if (defaultDateFormat) {
              setSelectedDateFormat({
                value: defaultDateFormat.CC_DM_ID,
                label: defaultDateFormat.CC_DM_DateFormat
              });
            }
          }

          // Set company channels from API response
          const channelsFromBackend = data.channelDetails?.map(channel =>
            channel.ChannelValue.toString()
          ) || [];
          setSelectedCompanyChannels(channelsFromBackend);

          // Set event types from API response
          const eventTypesFromBackend = data.eventTypeDetails?.map(event =>
            event.EEVM_EmailEventId?.toString() || event.ET_EventTypeValue?.toString()
          ) || [];
          setSelectedCompanyEventTypes(eventTypesFromBackend);

          // Fetch event type options if channels exist
          if (channelsFromBackend.length > 0 && data.CC_CMType) {
            try {
              setLoadingEventTypes(true);
              const eventTypeRes = await axios.post(
                `${config.API_URL}/companyeventtypes`,
                { selectedType: data.CC_CMType }
              );

              setCompanyEventTypeOptions(eventTypeRes.data.data || []);
              setLoadingEventTypes(false);
            } catch (error) {
              console.error("Error fetching event types in edit mode:", error);
              setLoadingEventTypes(false);
            }
          }

          // Set logo preview if exists
          if (data.CC_CompanyLogo) {
            setLogoPreview(`${config.API_URL}${data.CC_CompanyLogo}`);
          }

          const selectedrights = data.selectedrights || [];
          setStoredRights(selectedrights);

          const selectedRightKeys = new Set(
            selectedrights.map(
              (right) =>
                `${right.CSM_CompanymenuIndex}-${right.CSM_CompanySubmenuIndex}`
            )
          );

          // FIXED: Corrected the filteredMenus function for edit mode
          const filteredMenus = (menus, companyType) => {
            return (menus || [])
              .map((menuItem) => {
                const filteredSubMenus = menuItem.SubMenus.filter((subMenu) => {
                  const allowedRoles = Array.isArray(subMenu.SMNM_AllowedRoles)
                    ? subMenu.SMNM_AllowedRoles.map(Number)
                    : typeof subMenu.SMNM_AllowedRoles === "string"
                      ? subMenu.SMNM_AllowedRoles.split(",").map(r => Number(r.trim()))
                      : [];

                  const rightType = Number(subMenu.SMNM_RightType);

                  console.log(`[Edit Mode] Checking: ${subMenu.SMNM_SubMenuDisplay}`);
                  console.log(`  AllowedRoles:`, allowedRoles);
                  console.log(`  RightType:`, rightType);
                  console.log(`  Selected Company Type:`, companyType);

                  if (companyType === 1) return true;

                  if (
                    allowedRoles.length === 2 &&
                    allowedRoles.includes(2) &&
                    allowedRoles.includes(3)
                  ) {
                    return true;
                  }

                  if (allowedRoles.includes(0)) {
                    return rightType === 1 || rightType === companyType;
                  }

                  if (
                    allowedRoles.length === 1 &&
                    allowedRoles.includes(companyType)
                  ) {
                    return true;
                  }

                  if (allowedRoles.length === 1 && allowedRoles.includes(1)) {
                    return rightType === companyType;
                  }

                  if (allowedRoles.includes(companyType)) {
                    return rightType === 1 || rightType === companyType;
                  }

                  return false;
                });

                return {
                  ...menuItem,
                  SubMenus: filteredSubMenus,
                };
              })
              .filter((menuItem) => menuItem.SubMenus.length > 0);
          };

          const filtered = filteredMenus(
            fetchedData.companyRightRes,
            data.CC_CMType
          );

          console.log("Filtered menus count:", filtered.length);

          const keyObj = {};
          const disabledKeySet = new Set();
          singleChildRef.current = new Map();

          const menu = filtered.map((item) => {
            let disableParent = false;

            const children = item.SubMenus.map((child) => {
              const key = `${child.SMNM_MenuID}-${child.SMNM_SubMenuIndex}`;
              const isRequired = child.SMNM_IsRequired === 1;
              const isSelected = selectedRightKeys.has(key);

              if (isSelected || isRequired) {
                keyObj[key] = { checked: true, partialChecked: false };
              }

              if (isRequired) {
                disabledKeySet.add(key);
                disableParent = true;
              }

              return {
                key,
                label: child.SMNM_SubMenuDisplay,
                disabled: isRequired,
              };
            });

            const parentKey = item.MNM_MenuID.toString();
            const hasSelectedChild = children.some((child) =>
              selectedRightKeys.has(child.key)
            );

            if (disableParent || hasSelectedChild) {
              keyObj[parentKey] = { checked: true, partialChecked: false };
            }

            if (disableParent) {
              disabledKeySet.add(parentKey);
            }

            return {
              key: parentKey,
              label: item.MNM_MenuName,
              children: children,
              disabled: disableParent,
            };
          });

          // 🔥 CRITICAL FIX: Create a Set of ALL selected keys (including child keys and disabled keys)
          const allSelectedKeys = new Set();

          // Add all child keys that are selected or required
          Object.keys(keyObj).forEach(key => {
            allSelectedKeys.add(key);
          });

          // Add disabled keys (they might already be included, but Set handles duplicates)
          disabledKeySet.forEach(key => allSelectedKeys.add(key));

          console.log("All selected keys before buildCheckedState:", Array.from(allSelectedKeys));

          // ✅ Build proper checked state with partial parents
          const newSelectedKeys = buildCheckedState(allSelectedKeys);

          console.log("New selected keys after buildCheckedState:", newSelectedKeys);

          setNodes(menu);
          setDisabledKeys(disabledKeySet);
          setSelectedKeys(newSelectedKeys);
          setFormData((prev) => ({
            ...prev,
            selectRights: newSelectedKeys,
          }));

          console.log("Set nodes:", menu.length);
          console.log("Set selected keys:", Object.keys(newSelectedKeys).length);
        }
      } catch (error) {
        console.error("[CCHome] fetchData error", error);
        showToast('error', error?.response?.data?.message || "Something went wrong");
      } finally {
        if (safetyTimer) clearTimeout(safetyTimer);
        setIsLoading(false);
        console.log("[CCHome] fetchData: done, isLoading set false");
      }
    };

    const fetchDateFormats = async () => {
      try {
        const dateFormatRes = await axios.get(`${config.API_URL}/dateformats`);
        const dateFormats = dateFormatRes.data.data || [];
        setDateFormatOptions(dateFormats);
        return dateFormats;
      } catch (error) {
        console.error("Error fetching date formats:", error);
        return [];
      }
    };

    fetchData();
    fetchDateFormats();
  }, [id]);

  // Rest of the code remains the same from here...
  const handleDate = (date) => {
    setSelectedDate(date);
    setFormData((prev) => ({
      ...prev,
      "CC_RSNcutOffRequest": date
    }));
    validateField("CC_RSNcutOffRequest")
  };

  const handleCheckboxChange = (fieldID, event) => {
    const isChecked = event.target.checked;
    console.log(`Changing field ${fieldID} to isRequired: ${isChecked ? 1 : 0}`);

    setFormData((prev) => {
      const updatedFieldVal = prev.fieldVal.map((f) =>
        f.CFLC_FieldID === fieldID
          ? { ...f, CFLC_IsRequired: isChecked ? 1 : 0 }
          : f
      );

      console.log("Updated fieldVal:", updatedFieldVal);
      return {
        ...prev,
        fieldVal: updatedFieldVal,
      };
    });
  };

  const sortedPackingOption = [...packingOption].sort(
    (a, b) => b.PLM_PackingLevelValue - a.PLM_PackingLevelValue
  );

  const handleSwitchChange = (event) => {
    const isChecked = event.target.checked;
    setIsMaxUser(isChecked);

    setFormData((prev) => ({
      ...prev,
      CC_IsMaximumUserDefined: isChecked ? 1 : 0,
    }));

    if (!isChecked) {
      setFormData(prev => ({
        ...prev,
        CC_NoOfUser: "",
        CC_UserLimitExceedAction: "",
      }));
      setErrMsg({
        ...errMsg,
        CC_NoOfUser: "",
        CC_UserLimitExceedAction: "",
      });
    }
  };

  // ==================================================================================================================================
  // ==================================================================================================================================
  useEffect(() => {
    if (selectedType === 1 || selectedType === 2) {
      setIsMaxRSN(true);
      setFormData((prev) => ({
        ...prev,
        CC_IsRSNLimitDefined: 1,
      }));
    } else {
      setIsMaxRSN(false);
      setFormData((prev) => ({
        ...prev,
        CC_IsRSNLimitDefined: 0,
        CC_NoOfRSN: "",
        CC_RSNLimitExceedAction: "",
      }));
    }
  }, [selectedType]);

  const handleSwitchChange1 = (event) => {
    const isChecked = event.target.checked;
    setIsMaxRSN(isChecked);

    setFormData((prev) => ({
      ...prev,
      CC_IsRSNLimitDefined: isChecked ? 1 : 0,
      CC_NoOfRSN: isChecked ? prev.CC_NoOfRSN : "",
      CC_RSNLimitExceedAction: isChecked ? prev.CC_RSNLimitExceedAction : "",
    }));

    setErrMsg({
      ...errMsg,
      CC_NoOfRSN: "",
      CC_RSNLimitExceedAction: "",
    });
  };

  const handleSelectionChange = (e) => {
    const rawSelection =
      typeof e.value === "object" && !Array.isArray(e.value)
        ? Object.keys(e.value)
        : Array.isArray(e.value)
          ? e.value
          : [e.value];

    const selectedNow = new Set(rawSelection);
    const prevSelected = new Set(Object.keys(selectedKeys));

    const removed = [...prevSelected].filter((key) => !selectedNow.has(key));
    const updatedSelection = new Set();

    selectedNow.forEach((key) => {
      updatedSelection.add(key);
      const linked = singleChildRef.current.get(key);
      if (linked) {
        updatedSelection.add(linked);
      }
    });

    removed.forEach((key) => {
      const linked = singleChildRef.current.get(key);
      updatedSelection.delete(key);
      if (linked) {
        updatedSelection.delete(linked);
      }
    });

    Array.from(disabledKeys).forEach((key) => updatedSelection.add(key));

    const newSelectedKeys = {};
    updatedSelection.forEach((key) => {
      newSelectedKeys[key] = { checked: true, partialChecked: false };
    });

    const messageConfigKey = "2-3";
    const wasMessageConfigSelected = selectedKeys && selectedKeys[messageConfigKey]?.checked;
    const isMessageConfigSelected = newSelectedKeys[messageConfigKey]?.checked;

    if (wasMessageConfigSelected && !isMessageConfigSelected) {
      setSelectedCompanyChannels([]);
      setSelectedCompanyEventTypes([]);
      setFormData((prev) => ({
        ...prev,
        companyChannels: [],
        companyEventTypes: []
      }));
      setCompanyEventTypeOptions([]);
    }

    setSelectedKeys(newSelectedKeys);
    setFormData((prev) => ({
      ...prev,
      selectRights: newSelectedKeys,
    }));
  };

  const handleChangeFunction = (fieldID, value, name) => {
    if (name === "CPLM_Name") {
      setFormData((prev) => {
        const updatedPack = (prev.packinglevel || []).map((f) =>
          f.CPLM_PLM_ID === fieldID ? { ...f, [name]: value } : f
        );
        return {
          ...prev,
          packinglevel: updatedPack,
        };
      });

      setErrMsg(prev => {
        const newErrors = { ...prev };
        delete newErrors[`packing_name_${fieldID}`];
        return newErrors;
      });

      validateField(name, value, fieldID);
      return;
    }

    if (name === "CFLC_DisplayName" || name === "CFLC_Order") {
      let nextValue = value;

      if (name === "CFLC_DisplayName") {
        nextValue = value.replace(/[^a-zA-Z0-9 ]/g, "");
      }

      if (name === "CFLC_Order") {
        if (value === "" || value === null) {
          nextValue = null;
        } else if (!isPositiveIntegerString(value)) {
          showToast('error', "Order Number must be a positive integer");
          return;
        } else {
          const thisField = fieldOption.find((fo) => fo.FieldID === fieldID);
          const sectionCount = fieldOption.filter(
            (fo) =>
              thisField &&
              fo.ModuleName === thisField.ModuleName &&
              fo.IsMasterField === thisField.IsMasterField
          ).length;

          const asInt = parseInt(value, 10);
          if (asInt > sectionCount) {
            showToast('error', `Order Number cannot exceed ${sectionCount}`);
            return;
          }
          nextValue = asInt;
        }
      }

      setFormData((prev) => {
        const updatedFieldVal = prev.fieldVal.map((f) =>
          f.CFLC_FieldID === fieldID ? { ...f, [name]: nextValue } : f
        );
        return {
          ...prev,
          fieldVal: updatedFieldVal,
        };
      });

      if (name === "CFLC_Order") {
        setErrMsg(prev => {
          const newErrors = { ...prev };
          delete newErrors[`CFLC_Order_${fieldID}`];
          return newErrors;
        });

        setTimeout(() => {
          const newErrors = { ...errMsg };
          delete newErrors[`CFLC_Order_${fieldID}`];
          validateFormOnOrderChange(fieldID, nextValue);
        }, 100);
      }

      return;
    }
  };

  const validateFormOnOrderChange = (changedFieldID, newValue) => {
    if (!newValue || newValue === "") return;

    const fieldById = new Map(fieldOption.map((fo) => [fo.FieldID, fo]));
    const changedField = fieldOption.find(fo => fo.FieldID === changedFieldID);
    if (!changedField) return;

    const groupKey = `${changedField.ModuleName}|${changedField.IsMasterField}`;
    const fieldsInSameGroup = fieldOption.filter(
      fo => fo.ModuleName === changedField.ModuleName &&
        fo.IsMasterField === changedField.IsMasterField
    );

    const ordersInGroup = [];
    fieldsInSameGroup.forEach(field => {
      const fieldData = formData.fieldVal?.find(f => f.CFLC_FieldID === field.FieldID);
      if (fieldData && fieldData.CFLC_Order && field.FieldID !== changedFieldID) {
        ordersInGroup.push({
          fieldID: field.FieldID,
          order: fieldData.CFLC_Order,
          displayName: fieldData.CFLC_DisplayName || field.FieldName
        });
      }
    });

    const changedFieldData = formData.fieldVal?.find(f => f.CFLC_FieldID === changedFieldID);
    const changedFieldDisplayName = changedFieldData?.CFLC_DisplayName || changedField.FieldName;

    const duplicateFields = ordersInGroup.filter(item => item.order === newValue);

    setErrMsg(prev => {
      const newErrors = { ...prev };

      fieldsInSameGroup.forEach(field => {
        delete newErrors[`CFLC_Order_${field.FieldID}`];
      });

      if (duplicateFields.length > 0) {
        newErrors[`CFLC_Order_${changedFieldID}`] =
          `Duplicate order number ${newValue} found for field "${changedFieldDisplayName}"`;

        duplicateFields.forEach(dup => {
          newErrors[`CFLC_Order_${dup.fieldID}`] =
            `Duplicate order number ${newValue} found for field "${dup.displayName}"`;
        });
      }

      return newErrors;
    });
  };

  const validateField = (name, value, additionalParam) => {
    let errors = { ...errMsg };

    switch (name) {
      case "CC_CM_ID":
      case "CC_CMType":
      case "CC_PackingLevelForShipment":
      case "CC_NoOfUser":
      case "CC_UserLimitExceedAction":
      case "CC_NoOfRSN":
      case "CC_RSNLimitExceedAction":
      case "CC_Config_ID":
      case "CC_DateFormat":
      case "CC_RSNRequestConf":
      case "CC_SSCCRequestConf":
        delete errors[name];
        break;
      default:
        break;
    }

    if (name === "CPLM_Name") {
      const fieldId = additionalParam;
      if (fieldId) {
        delete errors[`packing_name_${fieldId}`];
      }
    }

    setErrMsg(errors);
  };

  const validateForm = () => {
    const errors = {};

    try {
      const fieldById = new Map(fieldOption.map((fo) => [fo.FieldID, fo]));
      const groupedOrders = new Map();

      (formData.fieldVal || []).forEach((fv) => {
        const meta = fieldById.get(fv.CFLC_FieldID);
        if (!meta) return;

        const groupKey = `${meta.ModuleName}|${meta.IsMasterField}`;
        if (!groupedOrders.has(groupKey)) {
          groupedOrders.set(groupKey, new Map());
        }

        const orderMap = groupedOrders.get(groupKey);
        const orderVal = fv.CFLC_Order;

        if (orderVal === null || orderVal === undefined || orderVal === "") return;

        const asNumber = Number(orderVal);
        const fieldIds = orderMap.get(asNumber) || [];
        fieldIds.push({
          id: fv.CFLC_FieldID,
          name: fv.CFLC_DisplayName || meta.FieldName
        });
        orderMap.set(asNumber, fieldIds);
      });

      const currentErrors = { ...errMsg };
      Object.keys(currentErrors).forEach(key => {
        if (key.startsWith('CFLC_Order_') && currentErrors[key].includes('Duplicate order number')) {
          delete errors[key];
        }
      });

      for (const [groupKey, orderMap] of groupedOrders.entries()) {
        for (const [orderVal, fieldEntries] of orderMap.entries()) {
          if (fieldEntries.length > 1) {
            fieldEntries.forEach((field) => {
              errors[`CFLC_Order_${field.id}`] =
                `Duplicate order number ${orderVal} found for field "${field.name}"`;
            });
          }
        }
      }

    } catch (e) {
      console.warn("CFLC_Order duplicate validation failed", e);
    }

    const fields = ["CC_CM_ID", "CC_CMType"];

    if (formData.CC_CMType?.toString() === '1' || formData.CC_CMType?.toString() === '2') {
      fields.push(
        "CC_RSNRequestConf",
        "CC_SSCCRequestConf",
        "CC_PackingLevelForShipment"
      );
    }

    if (formData.CC_IsMaximumUserDefined === 1) {
      fields.push("CC_UserLimitExceedAction", "CC_NoOfUser");
    }

    if ((formData.CC_CMType?.toString() === '1' || formData.CC_CMType?.toString() === '2') && formData.CC_IsRSNLimitDefined === 1) {
      fields.push("CC_RSNLimitExceedAction", "CC_NoOfRSN");
    }

    if (!formData.CC_DateFormat) {
      errors["CC_DateFormat"] = "*";
    }

    if (formData.selectRights && formData.selectRights["2-3"]?.checked && selectedType !== null) {
      if (!selectedCompanyChannels || selectedCompanyChannels.length === 0) {
        errors["companyChannels"] = "*";
      }

      if (selectedCompanyChannels && selectedCompanyChannels.length > 0) {
        if (companyEventTypeOptions.length > 0) {
          if (!selectedCompanyEventTypes || selectedCompanyEventTypes.length === 0) {
            errors["companyEventTypes"] = "*";
          }
        }
      }
    }

    fields.forEach((val) => {
      if (!formData[val] || formData[val] === "" || formData[val] === Infinity) {
        errors[val] = "*";
      }
    });

    if (formData.CC_CMType?.toString() === '1' || formData.CC_CMType?.toString() === '2') {
      const packingShipmentLevel = formData.CC_PackingLevelForShipment;
      const packingLevels = formData.packinglevel || [];

      const checkedPackingLevels = sortedPackingOption.filter(
        item => packingShipmentLevel <= item.PLM_ID
      );

      checkedPackingLevels.forEach(item => {
        const packingData = packingLevels.find(
          p => p.CPLM_PLM_ID === item.PLM_ID
        );

        if (!packingData || !packingData.CPLM_Name || packingData.CPLM_Name.trim() === "") {
          errors[`packing_name_${item.PLM_ID}`] = "*";
        }
      });
    }

    if (!formData.CC_ScanningMode || formData.CC_ScanningMode === "") {
      errors["CC_ScanningMode"] = "*";
    }

    setErrMsg(errors);
    return Object.keys(errors).length === 0;
  };

  const submitForm = async () => {
    if (!validateForm()) return;

    try {
      setIsLoading(true);

      const preparedData = { ...formData };
      const isSCP = preparedData.CC_CMType?.toString() === "3";

      const isMessageConfigSelected =
        selectedKeys && selectedKeys["2-3"]?.checked;

      if (!isMessageConfigSelected) {
        preparedData.companyChannels = [];
        preparedData.companyEventTypes = [];
      }

      if (preparedData.CC_PackingLevelForShipment === Infinity) {
        preparedData.CC_PackingLevelForShipment = null;
      }

      if (preparedData.CC_ScanningMode !== 1) {
        preparedData.CC_MaxRSNCount = null;
        preparedData.CC_MaxUserCount = null;
        preparedData.CC_ScanningInterval = null;
        preparedData.CC_AllowMultiScanSameUser = null;
        preparedData.CC_RSNSequenceType = null;
      }

      if (preparedData.CC_ScanningMode !== 2) {
        preparedData.CC_ScanningInterval = null;
      }

      if (!isSCP) {
        preparedData.CC_PackingLevelForShipment = null;
      }

      if (!id) {
        const payload = {
          ...preparedData,
          CC_IsMultipleScheme: preparedData.CC_IsMultipleScheme || 0,
          CC_ScanningMode: preparedData.CC_ScanningMode || null,
          companyChannels: preparedData.companyChannels || [],
          companyEventTypes: preparedData.companyEventTypes || [],
          ...(!isSCP && { packinglevel: preparedData.packinglevel }),
        };

        const createRes = await axios.post(
          `${config.API_URL}/createcompanyconfigure`,
          payload
        );

        if (createRes.data.success) {
            // Immediately add the newly configured company ID to the list
  const newCompanyId = formData.CC_CM_ID;
  setConfiguredCompanyIds(prev => [...prev, newCompanyId]);
  
          showToast("success", createRes.data.message, {
            autoClose: 3000,
            onClose: () => {
              resetForm();
              setIsLoading(false);
            },
          });
        } else {
          setIsLoading(false);
          showToast("error", createRes.data.message);
        }
      } else {
        const payload = {
          ...preparedData,
          CC_IsMultipleScheme: preparedData.CC_IsMultipleScheme || 0,
          CC_ScanningMode: preparedData.CC_ScanningMode || null,
          companyChannels: preparedData.companyChannels || [],
          companyEventTypes: preparedData.companyEventTypes || [],
          ...(!isSCP && { packinglevel: preparedData.packinglevel }),
        };

        const updateRes = await axios.put(
          `${config.API_URL}/updatecompanyconfigure`,
          payload
        );

        if (updateRes.data.success) {
          showToast("success", updateRes.data.message, {
            autoClose: 3000,
            onClose: () => {
              sessionStorage.removeItem("CC_ID");
              navigate("/dashboard/companyconfig");
              setIsLoading(false);
            },
          });
        } else {
          setIsLoading(false);
          showToast("error", updateRes.data.message || "Something went wrong");
        }
      }
    } catch (error) {
      setIsLoading(false);
      showToast(
        "error",
        error?.response?.data?.message ||
        "An error occurred while saving"
      );
    }
  };

  const handleInput = (e) => {
    const { name, value } = e.target;

    const numberOnlyFields = ["CC_NoOfUser", "CC_Maxplant", "CC_Maxproduct", "CC_NoOfRSN"];

    if (numberOnlyFields.includes(name)) {
      if (/^[1-9][0-9]*$/.test(value) || value === "") {
        setFormData((prev) => ({
          ...prev,
          [name]: value,
        }));
        validateField(name, value);
      }
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
      validateField(name, value);
    }
  };

  const handleSelectOpen = (selectName) => {
    setIsSelectOpen(selectName);
    if (selectName === "CC_UserLimitExceedAction" && (selectedType === 3)) {
      setTimeout(() => {
        const mainContainer = document.querySelector('.main_container');
        const dropdown = document.querySelector('.routing_select-box .react-select__menu');
        const dropdownHeight = dropdown ? dropdown.offsetHeight : 100;
        const gap = 20;
        if (mainContainer) {
          mainContainer.style.paddingBottom = `${dropdownHeight + gap}px`;
          mainContainer.scrollTo({
            top: mainContainer.scrollHeight,
            behavior: "smooth"
          });
        }
      }, 100);
    }
  };

  const handleSelectClose = () => {
    setIsSelectOpen(null);
    const mainContainer = document.querySelector('.main_container');
    if (mainContainer) {
      mainContainer.style.paddingBottom = '';
    }
  };

  return (
    <React.Fragment>
      <ToastContainer
        style={{
          marginTop: "73px",
          fontSize: "14px",
          width: "40%",
        }}
      />
      {isLoading && (
        <div style={{
          position: 'fixed',
          left: 0,
          top: 0,
          width: '100%',
          height: '100%',
          zIndex: 1000
        }} />
      )}
      <form autoComplete="off">
        <div className="main_container">
          <h3 className=" formHeading">Company Configuration</h3>
          {/* <div className="your-form-containe"> */}
            <div className="row d-flex">
              <div className="col-md-4">
                <div className="column">
                  {/* Company Name Dropdown */}
                  <div className="col-md-12">
                    <label className="form-label">
                      Company Name
                      <span className="error-message">{errMsg.CC_CM_ID}</span>
                    </label>
                    <div className="select-container ">
                      <Select
                        name="CC_CM_ID"
                        placeholder="--Select--"
                        options={getFilteredCompanyOptions().map(company => ({
                          value: company.CM_ID,
                          label: company.CM_CompanyName,
                          isDisabled: company.isDisabled && !id
                        }))}
                        value={companyOptions.find(company => company.CM_ID === formData?.CC_CM_ID) ?
                          { value: formData?.CC_CM_ID, label: companyOptions.find(company => company.CM_ID === formData?.CC_CM_ID)?.CM_CompanyName }
                          : null}
                        onChange={(selectedOption) => {
                          handleInput({
                            target: {
                              name: "CC_CM_ID",
                              value: selectedOption ? selectedOption.value : ""
                            }
                          });
                        }}
                        isDisabled={id ? true : false}
                        isOptionDisabled={(option) => option.isDisabled}
                        maxMenuHeight={120}
                        onMenuOpen={() => handleSelectOpen("CC_CM_ID")}
                        onMenuClose={handleSelectClose}
                        components={{ SingleValue: CustomSingleValue }}
                      />
                      <div className="icon-container_list myList">
                        {isSelectOpen === "CC_CM_ID" ? (
                          <IoCaretUpOutline />
                        ) : (
                          <IoCaretDownOutline />
                        )}
                      </div>
                    </div>
                  </div>
                  {/* Company Type */}
                  <div className="col-md-12">
                    <label className="form-label d-block mt-2">Company Type
                      <span className="error-message">{errMsg.CC_CMType}</span>
                    </label>
                    <div className="form-checke group_rights_container2"
                      style={{ maxHeight: "110px", minHeight: "110px", padding: "10px", overflowY: "auto" }}
                    >
                      {comtype.map((item) => (
                        <div key={item.EnumVal} className="col-sm- d-flex align-items-center">
                          <input
                            className="form-check-input mt-0 ms-0"
                            type="checkbox"
                            checked={
                              selectedType === item.EnumVal ||
                              (selectedType === 1 && (item.EnumVal === 2 || item.EnumVal === 3))
                            }
                            onChange={() => handleChange(item.EnumVal)}
                            id={`checkbox-${item.EnumVal}`}
                          />
                          <label className="form-label" style={{ width: "150px" }} htmlFor={`checkbox-${item.EnumVal}`}>
                            {item.Description}
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>
                  {/* Date Format Dropdown */}
                  <div className="col-md-12 mt-3">
                    <label className="form-label">
                      Date Format
                      <span className="error-message">{errMsg.CC_DateFormat}</span>
                    </label>
                    <div className="select-container">
                      <Select
                        key={selectedDateFormat}
                        options={dateFormatOptions.map(item => ({
                          value: item.CC_DM_ID,
                          label: item.CC_DM_DateFormat
                        }))}
                        value={selectedDateFormat}
                        onChange={handleDateFormatChange}
                        placeholder="--Select--"
                        maxMenuHeight={80}
                        onMenuOpen={() => handleSelectOpen("CC_DM_DateFormat")}
                        onMenuClose={handleSelectClose}
                        components={{ SingleValue: CustomSingleValue }}
                      />
                      <div className="icon-container_list myList">
                        {isSelectOpen === "CC_DM_DateFormat" ? (
                          <IoCaretUpOutline />
                        ) : (
                          <IoCaretDownOutline />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="column">
                  {selectedType !== null && (
                    <div className="col-md-12">
                      <label> User Rights     <span className="error-message">{errMsg.selectRights}</span></label>
                      <div className="group_rights_container1">
                        <Tree
                          checkable
                          checkStrictly={true}
                          selectable={false}
                          checkedKeys={{
                            checked: Object.keys(selectedKeys || {}).filter(
                              key => selectedKeys[key]?.checked
                            ),
                            halfChecked: Object.keys(selectedKeys || {}).filter(
                              key => selectedKeys[key]?.partialChecked
                            ),
                          }}
                          onCheck={handleCheck}
                          treeData={treeData}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
              {formData.selectRights && formData.selectRights["2-3"]?.checked && selectedType !== null && (
                <>
                  {/* Company Channel Checkboxes */}
                  <div className="col-md-4">
                    <div className="column">
                      <div className="col-md-12 ">
                        <label className="form-label">
                          Medium
                          {errMsg.companyChannels && <span className="error-message" style={{ marginLeft: '5px' }}>*</span>}
                        </label>
                        <div className="group_rights_container2 ">
                          {companyChannelOptions.map((channel) => (
                            <div
                              key={channel.EnumVal}
                              className="col-sm-3 d-flex align-items-center mb-"
                            >
                              <input
                                className="form-check-input mt-0 ms-0 me-2"
                                type="checkbox"
                                checked={selectedCompanyChannels.includes(channel.EnumVal.toString())}
                                onChange={(e) => handleCompanyChannelChange(e, channel)}
                                id={`channel-${channel.EnumVal}`}
                              />
                              <label
                                className="form-label mb-0"
                                htmlFor={`channel-${channel.EnumVal}`}
                                style={{ fontSize: '14px' }}
                              >
                                {channel.Description}
                              </label>
                            </div>
                          ))}
                        </div>
                      </div>
                      {/* Company Event Types Checkboxes */}
                      {selectedCompanyChannels.length > 0 && (
                        <div className="col-md-12 mt-2">
                          <div className="col-md-12">
                            <label className="form-label">
                              Company Event Types
                              {errMsg.companyEventTypes && <span className="error-message" style={{ marginLeft: '5px' }}>*</span>}
                            </label>
                          </div>

                          {loadingEventTypes ? (
                            <div className="col-md-12">
                              <small className="text-muted">Loading event types...</small>
                            </div>
                          ) : companyEventTypeOptions.length > 0 ? (
                            <>
                              <div className="group_rights_container3">
                                <div className="d-flex align-items-center mb-1">
                                  <input
                                    type="checkbox"
                                    checked={isAllEventTypesSelected()}
                                    onChange={toggleSelectAllEventTypes}
                                    id="select-all-event-types"
                                    className="form-check-input mt-0 ms-0 me-2"
                                    style={{ width: '18px', height: '18px' }}
                                  />
                                  <label
                                    className="form-label mb-0"
                                    htmlFor="select-all-event-types"
                                    style={{ fontSize: '14px' }}
                                  >
                                    Select All
                                  </label>
                                </div>
                                {companyEventTypeOptions.map((eventType) => (
                                  <div
                                    key={eventType.EEVM_EmailEventId}
                                    className="d-flex align-items-center"
                                  >
                                    <input
                                      type="checkbox"
                                      checked={selectedCompanyEventTypes.includes(eventType.EEVM_EmailEventId.toString())}
                                      onChange={(e) => handleCompanyEventTypeChange(e, eventType)}
                                      id={`event-${eventType.EEVM_EmailEventId}`}
                                      className="form-check-input mt-0 ms-0 me-2"
                                      style={{ width: '18px', height: '18px' }}
                                    />
                                    <label
                                      className="form-label mb-0"
                                      htmlFor={`event-${eventType.EEVM_EmailEventId}`}
                                      style={{ fontSize: '14px' }}
                                    >
                                      {eventType.EEVM_EventName}
                                    </label>
                                  </div>
                                ))}
                              </div>
                            </>
                          ) : (
                            <div className="col-md-12">
                              <small className="text-muted">No event types available for selected medium</small>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </>
              )}
            </div>

            <div className="row">
              {shouldShowSchemeAndScanningFields() && (
                <div className="col-md-4 mt-3 d-flex align-items-center form-switch ps-3">
                  <label className="form-label" htmlFor="isMultipleScheme-switch">
                    Enable Multiple Scheme</label>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="isMultipleScheme-switch"
                    checked={isMultipleScheme}
                    onChange={handleMultipleSchemeChange}
                  />
                </div>
              )}

              <div className="col-md-4 mt-3">
                <label className="form-label">
                  Scanning Mode
                  <span className="error-message">{errMsg.CC_ScanningMode}</span>
                </label>
                <div className=" group_rights_container2"
                  style={{ maxHeight: "110px", minHeight: "110px", padding: "10px", overflowY: "auto" }}
                >
                  <div className="d-flex align-items-center mb-1">
                    <input
                      type="checkbox"
                      id="scanning-mode-all"
                      className="form-check-input mt-0 ms-0 me-2"
                      checked={selectedScanningModes.includes(3)}
                      onChange={(e) => handleScanningModeChange(3, e.target.checked)}
                    />
                    <label
                      className="form-label mb-0"
                      htmlFor="scanning-mode-all"
                      style={{ fontSize: '14px' }}
                    >
                      Select All
                    </label>
                  </div>

                  <div className="d-flex align-items-center">
                    <input
                      type="checkbox"
                      id="scanning-mode-vendor"
                      className="form-check-input mt-0 ms-0 me-2"
                      checked={selectedScanningModes.includes(1)}
                      onChange={(e) => handleScanningModeChange(1, e.target.checked)}
                      style={{ width: '18px', height: '18px' }}
                    />
                    <label
                      className="form-label mb-0"
                      htmlFor="scanning-mode-vendor"
                      style={{ fontSize: '14px' }}
                    >
                      Vendor
                    </label>
                  </div>

                  <div className="d-flex align-items-center">
                    <input
                      type="checkbox"
                      id="scanning-mode-product"
                      className="form-check-input mt-0 ms-0 me-2"
                      checked={selectedScanningModes.includes(2)}
                      onChange={(e) => handleScanningModeChange(2, e.target.checked)}
                      style={{ width: '18px', height: '18px' }}
                    />
                    <label
                      className="form-label mb-0"
                      htmlFor="scanning-mode-product"
                      style={{ fontSize: '14px' }}
                    >
                      Product
                    </label>
                  </div>
                </div>
              </div>
            </div>

            {/* RSN Request configuration & SSCC Request Configuration */}
            {(selectedType === 2 || selectedType === 1) && (
              <div className="row">
                <div className="col-md-4 mt-3 d-flex align-items-center form-switch ps-3">
                  <label className="form-label" htmlFor="combination-switch2">
                    Mapping Bypass
                    <span className="error-message">{errMsg.CC_IsMappingBypassed}</span>
                  </label>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="combination-switch2"
                    checked={formData?.CC_IsMappingBypassed === 1}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        CC_IsMappingBypassed: e.target.checked ? 1 : 0,
                      }))
                    }
                  />
                </div>

                <div className="col-md-4 mt-3">
                  <label className="form-label">
                    RSN Request Configuration
                    <span className="error-message">{errMsg.CC_RSNRequestConf}</span>
                  </label>
                  <div className="select-container">
                    <Select
                      name="CC_RSNRequestConf"
                      placeholder="--Select--"
                      options={companyconfig.map(item => ({
                        value: item.EnumVal,
                        label: item.Description
                      }))}
                      value={companyconfig.find(item => item.EnumVal === formData?.CC_RSNRequestConf) ?
                        { value: formData?.CC_RSNRequestConf, label: companyconfig.find(item => item.EnumVal === formData?.CC_RSNRequestConf)?.Description }
                        : null}
                      onChange={(selectedOption) => {
                        handleInput({
                          target: {
                            name: "CC_RSNRequestConf",
                            value: selectedOption ? selectedOption.value : ""
                          }
                        });
                      }}
                      onMenuOpen={() => handleSelectOpen("CC_RSNRequestConf")}
                      onMenuClose={handleSelectClose}
                      components={{ SingleValue: CustomSingleValue }}
                    />
                    <div className="icon-container_list myList">
                      {isSelectOpen === "CC_RSNRequestConf" ? (
                        <IoCaretUpOutline />
                      ) : (
                        <IoCaretDownOutline />
                      )}
                    </div>
                  </div>
                </div>

                <div className="col-md-4 mt-3">
                  <label className="form-label">
                    SSCC Request Configuration
                    <span className="error-message">{errMsg.CC_SSCCRequestConf}</span>
                  </label>
                  <div className="select-container">
                    <Select
                      name="CC_SSCCRequestConf"
                      placeholder="--Select--"
                      options={companyconfig.map(item => ({
                        value: item.EnumVal,
                        label: item.Description
                      }))}
                      value={companyconfig.find(item => item.EnumVal === formData?.CC_SSCCRequestConf) ?
                        { value: formData?.CC_SSCCRequestConf, label: companyconfig.find(item => item.EnumVal === formData?.CC_SSCCRequestConf)?.Description }
                        : null}
                      onChange={(selectedOption) => {
                        handleInput({
                          target: {
                            name: "CC_SSCCRequestConf",
                            value: selectedOption ? selectedOption.value : ""
                          }
                        });
                      }}
                      onMenuOpen={() => handleSelectOpen("CC_SSCCRequestConf")}
                      onMenuClose={handleSelectClose}
                      components={{ SingleValue: CustomSingleValue }}
                    />
                    <div className="icon-container_list myList">
                      {isSelectOpen === "CC_SSCCRequestConf" ? (
                        <IoCaretUpOutline />
                      ) : (
                        <IoCaretDownOutline />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="row">
              <div className="col-md-4 mt-3 d-flex align-items-center form-switch ps-3">
                <label className="form-label" htmlFor="combination-switch">
                  Enable Maximum User Limit
                </label>
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="combination-switch"
                  checked={!!isMaxUser}
                  onChange={handleSwitchChange}
                />
              </div>

              {isMaxUser && (
                <>
                  <div className="col-md-4 mt-3">
                    <label className="form-label">
                      No. of User
                      <span className="error-message">
                        {errMsg.CC_NoOfUser}
                      </span>
                    </label>
                    <div className="select-container">
                      <input
                        type="text"
                        name="CC_NoOfUser"
                        className="form-input"
                        maxLength={8}
                        onChange={handleInput}
                        value={formData?.CC_NoOfUser || ""}
                      />
                    </div>
                  </div>

                  <div className="col-md-4 mt-3">
                    <label className="form-label">
                      Action
                      <span className="error-message">
                        {errMsg.CC_UserLimitExceedAction}
                      </span>
                    </label>
                    <div className="select-container">
                      <Select
                        name="CC_UserLimitExceedAction"
                        placeholder="--Select--"
                        options={userLimitOption.map(item => ({
                          value: item.EnumVal,
                          label: item.Description
                        }))}
                        value={userLimitOption.find(item => item.EnumVal === formData?.CC_UserLimitExceedAction) ?
                          { value: formData?.CC_UserLimitExceedAction, label: userLimitOption.find(item => item.EnumVal === formData?.CC_UserLimitExceedAction)?.Description }
                          : null}
                        onChange={(selectedOption) => {
                          handleInput({
                            target: {
                              name: "CC_UserLimitExceedAction",
                              value: selectedOption ? selectedOption.value : ""
                            }
                          });
                        }}
                        onMenuOpen={() => handleSelectOpen("CC_UserLimitExceedAction")}
                        onMenuClose={handleSelectClose}
                        components={{ SingleValue: CustomSingleValue }}
                      />
                      <div className="icon-container_list myList">
                        {isSelectOpen === "CC_UserLimitExceedAction" ? (
                          <IoCaretUpOutline />
                        ) : (
                          <IoCaretDownOutline />
                        )}
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>

            {(selectedType === 2 || selectedType === 1) && (
              <div className="row">
                <div className="col-md-4 mt-3 d-flex align-items-center form-switch ps-3">
                  <label className="form-label" htmlFor="combination-switch1">
                    Enable Maximum RSN Limit
                  </label>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="combination-switch1"
                    checked={!!isMaxRSN}
                    onChange={handleSwitchChange1}
                  />
                </div>

                {isMaxRSN && (
                  <>
                    <div className="col-md-4 mt-3">
                      <label className="form-label">
                        No. Of RSN
                        <span className="error-message">{errMsg.CC_NoOfRSN}</span>
                      </label>
                      <div className="select-container">
                        <input
                          type="text"
                          name="CC_NoOfRSN"
                          className="form-input"
                          maxLength={45}
                          onChange={handleInput}
                          value={formData?.CC_NoOfRSN || ""}
                        />
                      </div>
                    </div>

                    <div className="col-md-4 mt-3">
                      <label className="form-label">
                        Action
                        <span className="error-message">
                          {errMsg.CC_RSNLimitExceedAction}
                        </span>
                      </label>
                      <div className="select-container">
                        <Select
                          name="CC_RSNLimitExceedAction"
                          placeholder="--Select--"
                          options={rsnLimitOption.map(item => ({
                            value: item.EnumVal,
                            label: item.Description
                          }))}
                          value={rsnLimitOption.find(item => item.EnumVal === formData?.CC_RSNLimitExceedAction) ?
                            { value: formData?.CC_RSNLimitExceedAction, label: rsnLimitOption.find(item => item.EnumVal === formData?.CC_RSNLimitExceedAction)?.Description }
                            : null}
                          onChange={(selectedOption) => {
                            handleInput({
                              target: {
                                name: "CC_RSNLimitExceedAction",
                                value: selectedOption ? selectedOption.value : ""
                              }
                            });
                          }}
                          onMenuOpen={() => handleSelectOpen("CC_RSNLimitExceedAction")}
                          onMenuClose={handleSelectClose}
                          components={{ SingleValue: CustomSingleValue }}
                        />
                        <div className="icon-container_list myList">
                          {isSelectOpen === "CC_RSNLimitExceedAction" ? (
                            <IoCaretUpOutline />
                          ) : (
                            <IoCaretDownOutline />
                          )}
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            )}

            {(selectedType === 2 || selectedType === 1) && (
              <div className="row">
                <div className="col-md-4 mt-3">
                  <label className="form-label">
                    RSN Request Cutoff Date
                    <span className="error-message">{errMsg.CC_RSNcutOffRequest}</span>
                  </label>

                  <div className="select-container">
                    <DatePicker
                      placeholderText="--Select--"
                      selected={selectedDate}
                      onChange={handleDate}
                      minDate={new Date()}
                      dateFormat="dd-MM-yyyy"
                      className="form-input"
                      onKeyDown={(e) => e.preventDefault()}
                      onPaste={(e) => e.preventDefault()}
                    />
                    <div className='icon-container_list myList'>
                      <IoCalendarOutline />
                    </div>
                  </div>
                </div>

                <div className="col-md-4 mt-3">
                  <label className="form-label">
                    Maximum Plant
                    <span className="error-message">{errMsg.CC_Maxplant}</span>
                  </label>
                  <div className="select-container">
                    <input
                      type="text"
                      name="CC_Maxplant"
                      className="form-input"
                      maxLength={45}
                      onChange={handleInput}
                      value={formData?.CC_Maxplant || ""}
                    />
                  </div>
                </div>

                <div className="col-md-4 mt-3">
                  <label className="form-label">
                    Maximum Product
                    <span className="error-message">{errMsg.CC_Maxproduct}</span>
                  </label>
                  <div className="select-container">
                    <input
                      type="text"
                      name="CC_Maxproduct"
                      className="form-input"
                      maxLength={45}
                      onChange={handleInput}
                      value={formData?.CC_Maxproduct || ""}
                    />
                  </div>
                </div>
              </div>
            )}

            {(selectedType !== null && selectedType !== 3) && (
              <>
                <div className="row">
                  <div className="col-md-4 mt-3">
                    <label className="form-label">
                      Packing Level Configuration for Shipment{" "}
                      <span className="error-message">
                        {errMsg.CC_PackingLevelForShipment}
                      </span>
                    </label>
                    <div className="group_rights_container">
                      {sortedPackingOption.map((item) => (
                        <div
                          key={item.PLM_ID}
                          className=" d-flex justify-content-center align-items-center"
                        >
                          <div className="col-md-2">
                            <input
                              className="form-check-input mt-0 ms-0 me-2"
                              type="checkbox"
                              checked={
                                formData?.CC_PackingLevelForShipment <= item.PLM_ID
                              }
                              onChange={(e) => {
                                const isChecked = e.target.checked;
                                const level = item.PLM_ID;
                                setFormData((prev) => {
                                  let newLevel;
                                  if (isChecked) {
                                    newLevel = level;
                                  } else {
                                    const lower = sortedPackingOption
                                      .map((p) => p.PLM_ID)
                                      .filter((v) => v > level);
                                    newLevel =
                                      lower.length > 0
                                        ? Math.min(...lower)
                                        : Infinity;
                                  }
                                  return {
                                    ...prev,
                                    CC_PackingLevelForShipment: newLevel,
                                  };
                                });
                                validateField("CC_PackingLevelForShipment", level);
                              }}
                            />
                          </div>
                          <div className="col-md-10">
                            <label>{item.PLM_Name}</label>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  {(selectedType === 2 || selectedType === 1) && (
                    <div className="col-md-4">
                      <div className="col-md-12 mt-3">
                        <label className="form-label">
                          Packing Level Name Configuration
                        </label>
                      </div>
                      <div className="group_rights_container1">
                        {packingOption.map((item, index) => (
                          <div
                            key={item.PLM_ID}
                            className="col-sm-12 d-flex align-items-center mt-1"
                          >
                            <div className="col-md-5">
                              <label>{item.PLM_Name}{' '}
                                {formData.CC_PackingLevelForShipment <= item.PLM_ID && (
                                  <span className="error-message" style={{ fontSize: '11px', display: 'bloc' }}>
                                    {errMsg[`packing_name_${item.PLM_ID}`] || ""}
                                  </span>
                                )}
                              </label>
                            </div>
                            <div className="col-md-7">
                              <input
                                name="CPLM_Name"
                                value={
                                  formData?.packinglevel?.find(
                                    (f) => f.CPLM_PLM_ID === item.PLM_ID
                                  )?.CPLM_Name || ''
                                }
                                type="text"
                                onChange={(e) =>
                                  handleChangeFunction(
                                    item.PLM_ID,
                                    e.target.value,
                                    e.target.name
                                  )
                                }
                              />
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  <div className="col-md-4 mt-3">
                    <label className="form-label">
                      T&T Regulatory{" "}
                      <span className="error-message">{errMsg.selectedtandt}</span>
                    </label>
                    <div className="group_rights_container ">
                      {tandtoption.map((item) => (
                        <div
                          key={item.RM_CountryID}
                          className=" d-flex justify-content-center align-items-center"
                        >
                          <div className="col-md-2">
                            <input
                              className="form-check-input mt-0 ms-0 me-2"
                              type="checkbox"
                              checked={formData?.selectedtandt?.includes(
                                item.RM_CountryID
                              )}
                              onChange={(e) => {
                                const isChecked = e.target.checked;
                                const countryId = item.RM_CountryID;
                                setFormData((prev) => {
                                  const prevSelected = prev.selectedtandt || [];
                                  let updatedSelected = [];
                                  if (isChecked) {
                                    if (countryId === 0) {
                                      updatedSelected = [0];
                                    } else {
                                      updatedSelected = [...new Set([...prevSelected.filter(id => id !== 0), countryId])];
                                    }
                                  } else {
                                    updatedSelected = prevSelected.filter(id => id !== countryId);
                                  }
                                  return {
                                    ...prev,
                                    selectedtandt: updatedSelected,
                                  };
                                });
                                validateField("selectedtandt");
                              }}
                            />
                          </div>
                          <div className="col-md-10">
                            <label>{item.RM_CountryName}</label>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                {/* Product List Field Name Configuration */}
                <div className="col-md-12">
                  <div className="col-md-4 mt-3">
                    <label className="form-label">
                      Product List Field Name Configuration
                      {fieldOption
                        .filter(item => item.ModuleName === "Product Master" && item.IsMasterField === 0)
                        .some(item => {
                          const fieldData = formData?.fieldVal?.find(f => f.CFLC_FieldID === item.FieldID);
                          return (!fieldData?.CFLC_DisplayName || !fieldData?.CFLC_Order) &&
                            !errMsg[`CFLC_Order_${item.FieldID}`];
                        }) && <span className="error-message" style={{ marginLeft: '5px' }}>*</span>}
                    </label>
                  </div>
                  <div className="group_rights_containe">
                    {fieldOption
                      .filter(
                        (item) =>
                          item.ModuleName === "Product Master" &&
                          item.IsMasterField === 0
                      )
                      .map((item) => ({
                        ...item,
                        CFLC_Order: formData?.fieldVal?.find((f) => f.CFLC_FieldID === item.FieldID)?.CFLC_Order || Infinity,
                      }))
                      .sort((a, b) => (a.CFLC_Order || Infinity) - (b.CFLC_Order || Infinity))
                      .map((item) => {
                        const fieldData = formData?.fieldVal?.find(
                          (f) => f.CFLC_FieldID === item.FieldID
                        );
                        const hasRequiredError = !fieldData?.CFLC_DisplayName || !fieldData?.CFLC_Order;
                        const hasDuplicateError = errMsg[`CFLC_Order_${item.FieldID}`] &&
                          errMsg[`CFLC_Order_${item.FieldID}`].includes('Duplicate');

                        return (
                          <div
                            key={item.FieldID}
                            className="col-sm-12 d-flex align-items-center mt-1"
                          >
                            <div className="col-md-2">
                              <label>{item.FieldName}
                                {hasRequiredError && !hasDuplicateError && (
                                  <span className="error-message" style={{ marginLeft: '5px', fontSize: '11px' }}>*</span>
                                )}
                              </label>
                            </div>
                            <div className="col-md-4">
                              <input
                                name="CFLC_DisplayName"
                                value={fieldData?.CFLC_DisplayName || ""}
                                type="text"
                                onChange={(e) =>
                                  handleChangeFunction(
                                    item.FieldID,
                                    e.target.value,
                                    e.target.name
                                  )
                                }
                              />
                              {hasDuplicateError && (
                                <span className="error-message" style={{ fontSize: '11px', display: 'block', color: '#dc3545' }}>
                                  {errMsg[`CFLC_Order_${item.FieldID}`]}
                                </span>
                              )}
                            </div>
                            <div className="col-md-1 ms-2">
                              <input
                                name="CFLC_Order"
                                value={fieldData?.CFLC_Order || ""}
                                type="number"
                                min={1}
                                style={{ width: '60px', borderColor: hasDuplicateError ? '#dc3545' : '' }}
                                max={(() => {
                                  const thisField = fieldOption.find((fo) => fo.FieldID === item.FieldID);
                                  return (fieldOption || []).filter(
                                    (fo) =>
                                      thisField &&
                                      fo.ModuleName === thisField.ModuleName &&
                                      fo.IsMasterField === thisField.IsMasterField
                                  ).length || 1;
                                })()}
                                onChange={(e) =>
                                  handleChangeFunction(
                                    item.FieldID,
                                    e.target.value,
                                    e.target.name
                                  )
                                }
                              />
                            </div>
                            <div className="col-md-1">
                              <input
                                className="form-check-input mt-0 ms-0 me-2"
                                type="checkbox"
                                checked={fieldData?.CFLC_IsRequired === 1}
                                onChange={(e) => handleCheckboxChange(item.FieldID, e)}
                              />
                            </div>
                            <div className="col-md-2">
                              <label>Required</label>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                </div>

                {/* Product Master Field Name Configuration */}
                <div className="col-md-12">
                  <div className="col-md-4 mt-3">
                    <label className="form-label">
                      Product Master Field Name Configuration
                      {fieldOption
                        .filter(item => item.ModuleName === "Product Master" && item.IsMasterField === 1)
                        .some(item => {
                          const fieldData = formData?.fieldVal?.find(f => f.CFLC_FieldID === item.FieldID);
                          return (!fieldData?.CFLC_DisplayName || !fieldData?.CFLC_Order) &&
                            !errMsg[`CFLC_Order_${item.FieldID}`];
                        }) && <span className="error-message" style={{ marginLeft: '5px' }}>*</span>}
                    </label>
                  </div>
                  <div className="group_rights_containe">
                    {fieldOption
                      .filter(
                        (item) =>
                          item.ModuleName === "Product Master" && item.IsMasterField === 1
                      )
                      .map((item) => ({
                        ...item,
                        CFLC_Order: formData?.fieldVal?.find((f) => f.CFLC_FieldID === item.FieldID)?.CFLC_Order || Infinity,
                      }))
                      .sort((a, b) => (a.CFLC_Order || Infinity) - (b.CFLC_Order || Infinity))
                      .map((item) => {
                        const fieldData = formData?.fieldVal?.find(
                          (f) => f.CFLC_FieldID === item.FieldID
                        );
                        const hasRequiredError = !fieldData?.CFLC_DisplayName || !fieldData?.CFLC_Order;
                        const hasDuplicateError = errMsg[`CFLC_Order_${item.FieldID}`] &&
                          errMsg[`CFLC_Order_${item.FieldID}`].includes('Duplicate');

                        return (
                          <div
                            key={item.FieldID}
                            className="col-sm-12 d-flex align-items-center mt-1"
                          >
                            <div className="col-md-2">
                              <label>{item.FieldName}
                                {hasRequiredError && !hasDuplicateError && (
                                  <span className="error-message" style={{ marginLeft: '5px', fontSize: '11px' }}>*</span>
                                )}
                              </label>
                            </div>
                            <div className="col-md-4">
                              <input
                                name="CFLC_DisplayName"
                                value={fieldData?.CFLC_DisplayName || ""}
                                type="text"
                                onChange={(e) =>
                                  handleChangeFunction(
                                    item.FieldID,
                                    e.target.value,
                                    e.target.name
                                  )
                                }
                              />
                              {hasDuplicateError && (
                                <span className="error-message" style={{ fontSize: '11px', display: 'block', color: '#dc3545' }}>
                                  {errMsg[`CFLC_Order_${item.FieldID}`]}
                                </span>
                              )}
                            </div>
                            <div className="col-md-1 ms-2">
                              <input
                                name="CFLC_Order"
                                value={fieldData?.CFLC_Order || ""}
                                type="number"
                                min={1}
                                style={{ width: '60px', borderColor: hasDuplicateError ? '#dc3545' : '' }}
                                max={(() => {
                                  const thisField = fieldOption.find((fo) => fo.FieldID === item.FieldID);
                                  return (fieldOption || []).filter(
                                    (fo) =>
                                      thisField &&
                                      fo.ModuleName === thisField.ModuleName &&
                                      fo.IsMasterField === thisField.IsMasterField
                                  ).length || 1;
                                })()}
                                onChange={(e) =>
                                  handleChangeFunction(
                                    item.FieldID,
                                    e.target.value,
                                    e.target.name
                                  )
                                }
                              />
                            </div>
                            <div className="col-md-1">
                              <input
                                className="form-check-input mt-0 ms-0 me-2"
                                type="checkbox"
                                checked={fieldData?.CFLC_IsRequired === 1}
                                onChange={(e) => handleCheckboxChange(item.FieldID, e)}
                              />
                            </div>
                            <div className="col-md-2">
                              <label>Required</label>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                </div>

                {/* Batch List Field Name Configuration */}
                <div className="col-md-12">
                  <div className="col-md-4 mt-3">
                    <label className="form-label">
                      Batch List Field Name Configuration
                      {fieldOption
                        .filter(item => item.ModuleName === "Batch Master" && item.IsMasterField === 0)
                        .some(item => {
                          const fieldData = formData?.fieldVal?.find(f => f.CFLC_FieldID === item.FieldID);
                          return (!fieldData?.CFLC_DisplayName || !fieldData?.CFLC_Order) &&
                            !errMsg[`CFLC_Order_${item.FieldID}`];
                        }) && <span className="error-message" style={{ marginLeft: '5px' }}>*</span>}
                    </label>
                  </div>
                  <div className="">
                    {fieldOption
                      .filter(
                        (item) =>
                          item.ModuleName === "Batch Master" && item.IsMasterField === 0
                      )
                      .map((item) => ({
                        ...item,
                        CFLC_Order: formData?.fieldVal?.find((f) => f.CFLC_FieldID === item.FieldID)?.CFLC_Order || Infinity,
                      }))
                      .sort((a, b) => (a.CFLC_Order || Infinity) - (b.CFLC_Order || Infinity))
                      .map((item) => {
                        const fieldData = formData?.fieldVal?.find(
                          (f) => f.CFLC_FieldID === item.FieldID
                        );
                        const hasRequiredError = !fieldData?.CFLC_DisplayName || !fieldData?.CFLC_Order;
                        const hasDuplicateError = errMsg[`CFLC_Order_${item.FieldID}`] &&
                          errMsg[`CFLC_Order_${item.FieldID}`].includes('Duplicate');

                        return (
                          <div
                            key={item.FieldID}
                            className="col-sm-12 d-flex align-items-center mt-1"
                          >
                            <div className="col-md-2">
                              <label>{item.FieldName}
                                {hasRequiredError && !hasDuplicateError && (
                                  <span className="error-message" style={{ marginLeft: '5px', fontSize: '11px' }}>*</span>
                                )}
                              </label>
                            </div>
                            <div className="col-md-4">
                              <input
                                name="CFLC_DisplayName"
                                value={fieldData?.CFLC_DisplayName || ""}
                                type="text"
                                onChange={(e) =>
                                  handleChangeFunction(
                                    item.FieldID,
                                    e.target.value,
                                    e.target.name
                                  )
                                }
                              />
                              {hasDuplicateError && (
                                <span className="error-message" style={{ fontSize: '11px', display: 'block', color: '#dc3545' }}>
                                  {errMsg[`CFLC_Order_${item.FieldID}`]}
                                </span>
                              )}
                            </div>
                            <div className="col-md-1 ms-2">
                              <input
                                name="CFLC_Order"
                                value={fieldData?.CFLC_Order || ""}
                                type="number"
                                min={1}
                                style={{ width: '60px', borderColor: hasDuplicateError ? '#dc3545' : '' }}
                                max={(() => {
                                  const thisField = fieldOption.find((fo) => fo.FieldID === item.FieldID);
                                  return (fieldOption || []).filter(
                                    (fo) =>
                                      thisField &&
                                      fo.ModuleName === thisField.ModuleName &&
                                      fo.IsMasterField === thisField.IsMasterField
                                  ).length || 1;
                                })()}
                                onChange={(e) =>
                                  handleChangeFunction(
                                    item.FieldID,
                                    e.target.value,
                                    e.target.name
                                  )
                                }
                              />
                            </div>
                            <div className="col-md-1">
                              <input
                                className="form-check-input mt-0 ms-0 me-2"
                                type="checkbox"
                                checked={fieldData?.CFLC_IsRequired === 1}
                                onChange={(e) => handleCheckboxChange(item.FieldID, e)}
                              />
                            </div>
                            <div className="col-md-2">
                              <label>Required</label>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                </div>

                {/* Batch Master Field Name Configuration */}
                <div className="col-md-12">
                  <div className="col-md-4 mt-3">
                    <label className="form-label">
                      Batch Master Field Name Configuration
                      {fieldOption
                        .filter(item => item.ModuleName === "Batch Master" && item.IsMasterField === 1)
                        .some(item => {
                          const fieldData = formData?.fieldVal?.find(f => f.CFLC_FieldID === item.FieldID);
                          return (!fieldData?.CFLC_DisplayName || !fieldData?.CFLC_Order) &&
                            !errMsg[`CFLC_Order_${item.FieldID}`];
                        }) && <span className="error-message" style={{ marginLeft: '5px' }}>*</span>}
                    </label>
                  </div>
                  <div className="group_rights_containe">
                    {fieldOption
                      .filter(
                        (item) =>
                          item.ModuleName === "Batch Master" && item.IsMasterField === 1
                      )
                      .map((item) => ({
                        ...item,
                        CFLC_Order: formData?.fieldVal?.find((f) => f.CFLC_FieldID === item.FieldID)?.CFLC_Order || Infinity,
                      }))
                      .sort((a, b) => (a.CFLC_Order || Infinity) - (b.CFLC_Order || Infinity))
                      .map((item) => {
                        const fieldData = formData?.fieldVal?.find(
                          (f) => f.CFLC_FieldID === item.FieldID
                        );
                        const hasRequiredError = !fieldData?.CFLC_DisplayName || !fieldData?.CFLC_Order;
                        const hasDuplicateError = errMsg[`CFLC_Order_${item.FieldID}`] &&
                          errMsg[`CFLC_Order_${item.FieldID}`].includes('Duplicate');

                        return (
                          <div
                            key={item.FieldID}
                            className="col-sm-12 d-flex align-items-center mt-1"
                          >
                            <div className="col-md-2">
                              <label>{item.FieldName}
                                {hasRequiredError && !hasDuplicateError && (
                                  <span className="error-message" style={{ marginLeft: '5px', fontSize: '11px' }}>*</span>
                                )}
                              </label>
                            </div>
                            <div className="col-md-4">
                              <input
                                name="CFLC_DisplayName"
                                value={fieldData?.CFLC_DisplayName || ""}
                                type="text"
                                onChange={(e) =>
                                  handleChangeFunction(
                                    item.FieldID,
                                    e.target.value,
                                    e.target.name
                                  )
                                }
                              />
                              {hasDuplicateError && (
                                <span className="error-message" style={{ fontSize: '11px', display: 'block', color: '#dc3545' }}>
                                  {errMsg[`CFLC_Order_${item.FieldID}`]}
                                </span>
                              )}
                            </div>
                            <div className="col-md-1 ms-2">
                              <input
                                name="CFLC_Order"
                                value={fieldData?.CFLC_Order || ""}
                                type="number"
                                min={1}
                                style={{ width: '60px', borderColor: hasDuplicateError ? '#dc3545' : '' }}
                                max={(() => {
                                  const thisField = fieldOption.find((fo) => fo.FieldID === item.FieldID);
                                  return (fieldOption || []).filter(
                                    (fo) =>
                                      thisField &&
                                      fo.ModuleName === thisField.ModuleName &&
                                      fo.IsMasterField === thisField.IsMasterField
                                  ).length || 1;
                                })()}
                                onChange={(e) =>
                                  handleChangeFunction(
                                    item.FieldID,
                                    e.target.value,
                                    e.target.name
                                  )
                                }
                              />
                            </div>
                            <div className="col-md-1">
                              <input
                                className="form-check-input mt-0 ms-0 me-2"
                                type="checkbox"
                                checked={fieldData?.CFLC_IsRequired === 1}
                                onChange={(e) => handleCheckboxChange(item.FieldID, e)}
                              />
                            </div>
                            <div className="col-md-2">
                              <label>Required</label>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                </div>
              </>
            )}
          {/* </div> */}
        </div>

        <div className="button-container">
          <button type="button" className="save_btn" onClick={submitForm} disabled={updateButtondisabled}>
            SAVE
          </button>
          <button type="button" className="reset_btn" onClick={resetForm}>
            RESET
          </button>
          <Link
            to={`/cclist`}
            onClick={() => {
              sessionStorage.removeItem("CC_ID");
              navigate(`/cclist`);
            }}
            className="list_btn"
            type="button"
          >
            LIST
          </Link>
        </div>
      </form>
    </React.Fragment>
  );
};

export default CCHome;






